import React, { useEffect, useRef, useState } from 'react'
import BreadCrumb from '../../utilities/BreadCrumb'
import { FastField, Formik, Form, Field } from 'formik';
import {
    SelectInput,
    NumberFormatInput, CheckBoxInput,
    PercentageInput,
    FormInput
} from '../../form-helpers'
import Modal from 'react-modal'
import { Document, Page, pdfjs } from 'react-pdf';
import { calculateDiscounts, calculateRefundRate, calculateSaasFees, formatPricing, formatText, getAdjustedCPM, getApexStorage, getModel, getPercentagePaid, RenderEnterpriseLogo, setEnterpriseLogo } from '../common';
import DateRPicker from '../../render-helpers/DateRPicker';
import { MONTHLY_SPEND_BAND, SUPPORT_OPTIONS, createCPMObject, generateCPMArray } from './data';
import Yup from '../../form-helpers/Yup';
import classNames from 'classnames';
import CustomDatePicker from '../../form-helpers/DatePicker';
import { pushLocation } from '../../utilities/customRoutes';
import "./index.scss"

import { getDealTypeFormatCarousel, emptyDealTypeFormatCarousel } from '../../../redux/audiences/contextual/contextual-media.actions';
import { connect } from 'react-redux';
import { emptyObjectives, getAllObjectives, getCMPByCountryModel } from '../../../redux/showcase/helpers/helpers.actions';
import FormatCarouselModal from '../../audiences/contextual/create-deal/options/format-carousel/FormatCarouselModal';
import { StatusFilter } from '../../render-helpers';

import AcceptModal from './models/accept';
import FeeModal from './models/fee';
import SupportModal from './models/support';
import DiscountSellCPMModal from './models/discount_sell_cpm';
import CriteoModal from './models/criteo';
import AgreementModal from './models/active_agreement';
import BilledByAgencyArrow from './arrow';
import { numberWithCommas } from '../../utilities/customFunctions';
import Toggle from 'react-toggle';
import { renderClientFacingField, renderDiscountedCPMField } from './helpers/render';
import PublisherPrioritization from './publisher';
import { config } from '../../../helpers';

const commbank = true;//config.commbank


let DiscountSchema = Yup.object().shape({
    prem_spend: Yup.string().required('Required'),
    adv_spend: Yup.string().required('Required'),
    monthly_spend_prem: Yup.string().required('Required'),
    monthly_spend_adv: Yup.string().required('Required')
})

const renderFastField = (label, placeholder, name, type = "text", disabled = false, textArea = false, isOptional = false) => {
    return (
        <FastField className="mb-1" containerClassName="form-row col-md-12  align-items-center" inputContainerClassName="col-6"
            labelClassName="col-6 text-right mb-1 pt-0" label={label} placeholder={placeholder}
            name={name} component={FormInput} type={type}
            disabled={disabled} isOptional={isOptional}
        />
    )
}


function Rates(props) {
    pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';
    const apex = getApexStorage()
    const model = getModel()
    const isBudIndependent = model === 1

    /* Country check */

    const COUNTRY = props?.user?.timeZone === "Pacific/Auckland" ? "NZ" : 'AU';
    const isAU = COUNTRY === 'AU';

    const monthlySpendBand = () => MONTHLY_SPEND_BAND.filter(item => item.country === COUNTRY);
    let minCPM = isAU ? 20 : 15
    let maxCPM = isAU ? 50 : 35
    let advCPM = isAU ? 24 : 17
    //let maxCPM = isAU ? 50 : 35
    let liteCPM = 7
    let skinCPM = formatPricing[3]

    const PREMIUM_CPM = generateCPMArray(minCPM, maxCPM)
    const ADVANCED_CPM = [...PREMIUM_CPM]
    const PREMIUM_CPM_DISCOUNT_ALL = isAU ? generateCPMArray(18, 35) : generateCPMArray(15, 35)
    const ADVANCED_CPM_DISCOUNT_ALL = isAU ? generateCPMArray(22, 35) : generateCPMArray(17, 35)
    
    const LITE_CPM = isAU ? generateCPMArray(5, 50) : generateCPMArray(5, 35)
    const SKIN_CPM = isAU ? generateCPMArray(20, 50) : generateCPMArray(25, 35)
    const LITE_CPM_DISCOUNT_ALL = isAU ? generateCPMArray(7, 35) : generateCPMArray(7, 35)
    const SKIN_CPM_DISCOUNT_ALL = isAU ? generateCPMArray(formatPricing[3], 50) : generateCPMArray(formatPricing[3], 50)

    const totalSpendSumCheck = isAU ? 50000 : 20000

    let Schema = Yup.object().shape({
        premium_spend_2: Yup.string().required('Required'),
        advanced_spend_2: Yup.string().required('Required'),
        monthly_spend_premium: Yup.string().required('Required'),
        monthly_spend_advanced: Yup.string().required('Required'),

        lite_spend_2: Yup.string().required('Required'),
        skin_spend_2: Yup.string().required('Required'),
        monthly_spend_lite: Yup.string().required('Required'),
        monthly_spend_skin: Yup.string().required('Required'),

        sumCheck: Yup.mixed().test(
            'sum-check',
            `The combined sum of monthly spend must be at least ${numberWithCommas(totalSpendSumCheck)}.`,
            function () {
                const { monthly_spend_premium, monthly_spend_advanced, monthly_spend_lite, monthly_spend_skin  } = this.parent;

                // If either field is missing or invalid, skip combined check
                if (!monthly_spend_premium || !monthly_spend_advanced) return true;

                const num1 = parseFloat(monthly_spend_premium);
                const num2 = parseFloat(monthly_spend_advanced);
                const num3 = parseFloat(monthly_spend_lite);
                const num4 = parseFloat(monthly_spend_skin);

                if (isNaN(num1) || isNaN(num2)) {
                    return this.createError({ message: 'Both fields must be valid numbers.' });
                }

                // Fail the test if the sum is less than 50,000
                return (num1 + num2 + num3 + num4) >= totalSpendSumCheck;
            }
        )

    })

    /* End of country check */


    const [numPages, setNumPages] = useState(null);
    const [showCalculation, setShowCalculation] = useState(true)
    const [isCalcModalOpen, setIsCalcModalOpen] = useState(false)
    const [isDiscountCalcModalOpen, setIsDiscountCalcModalOpen] = useState(false)
    const [isRefundCalcModalOpen, setIsRefundCalcModalOpen] = useState(false)
    const [showDiscountMargin, setShowDiscountMargin] = useState(false)
    const [isCarouselModalOpen, setIsCarouselModalOpen] = useState(false)
    const [obj, setObj] = useState('')

    const [pm2, setPm2] = useState(PREMIUM_CPM[0])
    const [ad2, setAd2] = useState(PREMIUM_CPM[isAU ? 4 : 2])

    const [li2, setLi2] = useState(LITE_CPM[5]) //used for calculator 
    const [sk2, setSk2] = useState(SKIN_CPM[10])

    const [prem_spend_set, setPrem_spend_set] = useState(0)
    const [adv_spend_set, setAdv_spend_set] = useState(0)
    const [lite_spend_set, setLite_spend_set] = useState(0)
    const [skin_spend_set, setSkin_spend_set] = useState(0)

    const [prem_base_set, setPrem_base_set] = useState(PREMIUM_CPM_DISCOUNT_ALL[0])
    const [adv_base_set, setAdv_base_set] = useState(ADVANCED_CPM_DISCOUNT_ALL[0])
    const [lite_base_set, setLite_base_set] = useState(LITE_CPM_DISCOUNT_ALL[0])
    const [skin_base_set, setSkin_base_set] = useState(SKIN_CPM_DISCOUNT_ALL[0])

    const [isManagedService, setIsManagedService] = useState(false)

    const divTCsRef = useRef(null);
    const [scrollTCsAtBottom, setScrollTCsAtBottom] = useState(false)

    const aaButtonRef = useRef(null);
    const baButtonRef = useRef(null);

    const formik = useRef(null);
    const calcFormik = useRef(null);
    const tcsURL = model === 1 ? "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/download/tcs/Bud+Enterprise+Independent+T%26C's.pdf"
        : model === 2 ? "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/download/tcs/Bud+Enterprise+Unified+Refund+T%26C's.pdf"
            : "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/download/tcs/Bud+Enterprise+Unified+Discount+T%26C's.pdf"


    //const containerClass = "form-row col-md-12 mb-3", inputClass = "col-sm-12 col-md-6 align-self-center", labelClass = "col-auto col-md-6"
    const containerClass = "form-row col-md-12 mb-3",
        inputClass = "col-sm-12 col-md-7",
        labelClass = "col-md-5 pt-2 text-right ";

    useEffect(() => {
        document.getElementById("root").classList.add("root-light");

        setEnterpriseLogo();


         if (COUNTRY && model) {            
            props.getCMPByCountryModel(isAU ? "AU" : "NZ", apex)
        }

        const scrollableDiv = document.querySelector(".bb-tcs-container");

        const handleScroll = () => {
            if (divTCsRef.current && !scrollTCsAtBottom) {
                const { scrollTop, scrollHeight, clientHeight } = divTCsRef.current;

                if (scrollTop + clientHeight >= (scrollHeight - 500)) {
                    setScrollTCsAtBottom(true);

                    if (scrollableDiv) {
                        scrollableDiv.removeEventListener("scroll", handleScroll);
                    }
                }
            }
        };


        if (scrollableDiv) {
            scrollableDiv.addEventListener("scroll", handleScroll);
        }
        if(commbank){
            handleManageService(true, formik?.current.setFieldValue, 'managed_service')
            handleManageService(true, formik?.current.setFieldValue, 'managed_service_refund')
            handleManageService(true, formik?.current.setFieldValue, 'managed_service_discount')
        }

        return () => {
            document.getElementById("root").classList.remove("root-light");
            if (scrollableDiv) {
                scrollableDiv.removeEventListener("scroll", handleScroll);
            }
        }
    }, [])

    const handleApproveClick = (ref) => {
        if (ref.current) {
            ref.current.textContent =
                ref.current.textContent = "Approved";
        }
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
    const renderTAndC = () => {
        return (
            // <div className="row col-md-12 mb-3 flex-column">
            // <label className="bb-form-input-label col-sm-12 col-md-3">Terms & Conditions</label>
            <div className={classNames(containerClass, "justify-content-center")}>
                <label className={"col-7 pt-2 "}>Terms & Conditions</label>
                <div className="col-7 ">
                    <Document
                        file={tcsURL}
                        // options={{ worker: '/pdf.worker.js', }}
                        onLoadSuccess={onDocumentLoadSuccess}
                        inputRef={divTCsRef}
                        className={' ml-1 bb-tcs-container form-control large'}
                        externalLinkTarget="_blank"
                        loading="Loading T&Cs..."
                        noData="Error getting T&Cs. Please download."
                        error="Error getting T&Cs. Please download."
                    >
                        {
                            numPages && Array.from(
                                new Array(numPages),
                                (el, index) => (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        loading=""
                                        error=""
                                        width={750}
                                        renderAnnotationLayer={false}
                                    />
                                ),
                            )
                        }
                    </Document>
                    <span className="hvr-underline-from-center font-weight-bold bb-text_small mt-1 ml-3"
                        onClick={() => { window.open(tcsURL, "_blank") }}>Download T&C</span>
                </div>
            </div>
        )
    }


    const handleCalculation = async (setFieldValue) => {

        const { premium_spend, advanced_spend, lite_spend, skin_spend, 
                monthly_spend, 
                premium_spend_set, advanced_spend_set, lite_spend_set, skin_spend_set, 
            } = formik?.current?.values

        if (premium_spend && advanced_spend && monthly_spend) {

            if (model === 1) {
                await setFieldValue("percentage", getPercentagePaid(apex, monthly_spend.label, premium_spend.value, advanced_spend.value,
                     lite_spend.value, skin_spend.value, COUNTRY, props.CMPModel))
            }

            setPm2(premium_spend)
            setAd2(advanced_spend)
            setLi2(lite_spend)
            setSk2(skin_spend)

            if (model === 3 || model === 2) {
                let adj = getAdjustedCPM(apex, monthly_spend.label, premium_spend.value, advanced_spend.value, lite_spend.value, skin_spend.value, COUNTRY, props.CMPModel)
                await setFieldValue("set_adjusted_cpm_prem", adj.prem)
                await setFieldValue("set_adjusted_cpm_adv", adj.adv)
                await setFieldValue("set_adjusted_cpm_lite", adj.lite)
                await setFieldValue("set_adjusted_cpm_skin", adj.skin)

                if (model === 2) {
                    let p = premium_spend_set.value,
                        a = advanced_spend_set.value,
                        l = lite_spend_set.value,
                        s = skin_spend_set.value                        ;
                    //console.log(adj, advanced_spend_set)
                    let p_r = (((p - Number(adj.prem)) / p) * 100).toFixed(2)
                    let a_r = (((a - Number(adj.adv)) / a) * 100).toFixed(2)
                    let l_r = (((l - Number(adj.lite)) / l) * 100).toFixed(2)
                    let s_r = (((s - Number(adj.skin)) / s) * 100).toFixed(2)
                    //console.log(l_r, p_r, a_r,  s_r)
                    let pr = isAU ? Math.min(p_r, a_r, l_r) : Math.min(p_r, a_r) //no skin check
                    await setFieldValue("percentage_refund", pr < 0 ? 0 : pr )
                }
                if(model === 3){         
                    await setFieldValue("percentage_discount", getPercentagePaid(apex, monthly_spend.label, premium_spend.value, advanced_spend.value,
                        lite_spend.value, skin_spend.value, COUNTRY,  props.CMPModel))
                }
            }

        }
    }

    const calculateFees = (values, setFieldValue) => {

        const { premium_spend_2, advanced_spend_2, monthly_spend_premium, monthly_spend_advanced, 
            lite_spend_2, skin_spend_2, monthly_spend_lite, monthly_spend_skin, 
         } = values

        //if (premium_spend_2 && advanced_spend_2 && ((monthly_spend_premium + monthly_spend_advanced) >= totalSpendSumCheck)) {
            let fees = calculateSaasFees(apex, Number(monthly_spend_premium), Number(monthly_spend_advanced), premium_spend_2.value, advanced_spend_2.value, 
            Number(monthly_spend_lite), Number(monthly_spend_skin), lite_spend_2.value, skin_spend_2.value,
            COUNTRY, props.CMPModel)

            //setFieldValue("usage_saas_fee", 10)
            setFieldValue("usage_saas_fee_percentage", fees.percentagePaid)
            setFieldValue("bigads_saas_fee_percentage", fees.totalSaasFeePercentage)
            setFieldValue("bigads_saas_fee", fees.totalSaasFee)
            setFieldValue("paid_to_apex", fees.saasFee)
            setFieldValue("annual_earnings", fees.annual_earnings)
            setFieldValue("annual_fee", fees.annual_fee)
            setFieldValue("total_predicted_spend", fees.total_predicted_spend)
            setShowCalculation(true)
        //}
    }

    const handleSetSellCPM = async (setFieldValue) => {

        const { premium_spend_set, advanced_spend_set, lite_spend_set, skin_spend_set } = formik?.current?.values
        setPrem_spend_set(premium_spend_set)
        setAdv_spend_set(advanced_spend_set)
        setLite_spend_set(lite_spend_set)
        setSkin_spend_set(skin_spend_set)

        if (premium_spend_set || advanced_spend_set || lite_spend_set || skin_spend_set) {
            setShowDiscountMargin(true)

            if (model === 2 || model === 3) {
                handleCalculation(setFieldValue)
            }
        }
    }

    const calculateDiscountFees = async (values, setFieldValue) => {
        const { prem_spend, adv_spend, monthly_spend_prem, monthly_spend_adv, lite_spend, skin_spend, monthly_spend_lite, monthly_spend_skin } = values

        //if (prem_spend && adv_spend && ((monthly_spend_prem + monthly_spend_adv) >= totalSpendSumCheck)) {

            let fees = calculateDiscounts(Number(monthly_spend_prem), Number(monthly_spend_adv),Number(monthly_spend_lite), Number(monthly_spend_skin), prem_spend.value, adv_spend.value, lite_spend.value, skin_spend.value, COUNTRY, props.CMPModel)
            console.log(fees)
            //setFieldValue("usage_saas_fee", 10)
            await setFieldValue("imp_purchased_prem", fees.imp_purchased.prem)
            await setFieldValue("imp_purchased_adv", fees.imp_purchased.adv)
            await setFieldValue("imp_purchased_lite", fees.imp_purchased.lite)
            await setFieldValue("imp_purchased_skin", fees.imp_purchased.skin)

            await setFieldValue("vol_discount_percentage_prem", fees.vol_discount.prem)
            await setFieldValue("vol_discount_percentage_adv", fees.vol_discount.adv)
            await setFieldValue("vol_discount_percentage_lite", fees.vol_discount.lite)
            await setFieldValue("vol_discount_percentage_skin", fees.vol_discount.skin)

            await setFieldValue("adjusted_cpm_prem", fees.adjusted_cpm.prem)
            await setFieldValue("adjusted_cpm_adv", fees.adjusted_cpm.adv)
            await setFieldValue("adjusted_cpm_lite", fees.adjusted_cpm.lite)
            await setFieldValue("adjusted_cpm_skin", fees.adjusted_cpm.skin)

            await setFieldValue("imp_increase_prem", fees.imp_increase.prem)
            await setFieldValue("imp_increase_adv", fees.imp_increase.adv)
            await setFieldValue("imp_increase_lite", fees.imp_increase.lite)
            await setFieldValue("imp_increase_skin", fees.imp_increase.skin)

            await setFieldValue("adjusted_imp_prem", fees.adjusted_imp.prem)
            await setFieldValue("adjusted_imp_adv", fees.adjusted_imp.adv)
            await setFieldValue("adjusted_imp_lite", fees.adjusted_imp.lite)
            await setFieldValue("adjusted_imp_skin", fees.adjusted_imp.skin)


            setShowCalculation(true)
            if (showDiscountMargin) {
                calculateMargin(setFieldValue)
            }
        //}
    }

    const calculateRefundRates = async (values, setFieldValue) => {
        const { prem_spend, adv_spend, monthly_spend_prem, monthly_spend_adv, monthly_spend_lite, monthly_spend_skin, lite_spend, skin_spend } = values

        //if (prem_spend && adv_spend && ((monthly_spend_prem + monthly_spend_adv) >= totalSpendSumCheck)) {

            let fees = calculateRefundRate(Number(monthly_spend_prem), Number(monthly_spend_adv), Number(monthly_spend_lite),Number(monthly_spend_skin),prem_spend.value, adv_spend.value, lite_spend.value, skin_spend.value, COUNTRY, props.CMPModel)
            console.log("refund", fees)

            await setFieldValue("adjusted_cpm_prem", fees.adjusted_cpm.prem)
            await setFieldValue("adjusted_cpm_adv", fees.adjusted_cpm.adv)
            await setFieldValue("adjusted_cpm_lite", fees.adjusted_cpm.lite)
            await setFieldValue("adjusted_cpm_skin", fees.adjusted_cpm.skin)

            calculateRefund(setFieldValue)
          
        //}
    }

    const calculateRefund = async (setFieldValue, updatePercentage = true) => {
        const { proposed_sell_cpm_prem, proposed_sell_cpm_adv, proposed_sell_cpm_lite, proposed_sell_cpm_skin, 
            adjusted_cpm_prem, adjusted_cpm_adv, adjusted_cpm_lite, adjusted_cpm_skin, 
            monthly_spend_prem, monthly_spend_adv, monthly_spend_lite, monthly_spend_skin,
        } = calcFormik?.current?.values

        let tmm = 0;

        let client_facing_cpm_prem = proposed_sell_cpm_prem.value
        let client_facing_cpm_adv = proposed_sell_cpm_adv.value
        let client_facing_cpm_lite = proposed_sell_cpm_lite.value
        let client_facing_cpm_skin = proposed_sell_cpm_skin.value
        
        /* PREM */
        let proposed_sell_cpm_percentage_prem = (((client_facing_cpm_prem - adjusted_cpm_prem) / adjusted_cpm_prem) * 100).toFixed(2)        
        let refund_percentage_prem = adjusted_cpm_prem > 0 ? (((client_facing_cpm_prem - adjusted_cpm_prem) / client_facing_cpm_prem) * 100 ).toFixed(2) : 0
        let refund_cpm_prem = adjusted_cpm_prem > 0 ? client_facing_cpm_prem - adjusted_cpm_prem : 0
        let monthly_refund_prem = Math.floor((refund_percentage_prem * monthly_spend_prem)/100)
        
        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_prem', proposed_sell_cpm_percentage_prem)
        await setFieldValue('refund_percentage_prem', refund_percentage_prem)
        await setFieldValue('refund_cpm_prem', refund_cpm_prem.toFixed(2))
        await setFieldValue('monthly_refund_prem', monthly_refund_prem)

        /* ADV */
        let proposed_sell_cpm_percentage_adv = (((client_facing_cpm_adv - adjusted_cpm_adv) / adjusted_cpm_adv) * 100).toFixed(2)        
        let refund_percentage_adv =  adjusted_cpm_adv > 0 ? (((client_facing_cpm_adv - adjusted_cpm_adv) / client_facing_cpm_adv) * 100 ).toFixed(2) : 0
        let refund_cpm_adv = adjusted_cpm_adv > 0 ? client_facing_cpm_adv - adjusted_cpm_adv : 0
        let monthly_refund_adv = Math.floor((refund_percentage_adv * monthly_spend_adv)/100)

        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_adv', proposed_sell_cpm_percentage_adv)
        await setFieldValue('refund_percentage_adv', refund_percentage_adv)
        await setFieldValue('refund_cpm_adv', refund_cpm_adv.toFixed(2))
        await setFieldValue('monthly_refund_adv', monthly_refund_adv)

        /* lite */
        let proposed_sell_cpm_percentage_lite = (((client_facing_cpm_lite - adjusted_cpm_lite) / adjusted_cpm_lite) * 100).toFixed(2)        
        let refund_percentage_lite =  adjusted_cpm_lite > 0 ? (((client_facing_cpm_lite - adjusted_cpm_lite) / client_facing_cpm_lite) * 100 ).toFixed(2) : 0
        let refund_cpm_lite = adjusted_cpm_lite > 0 ? client_facing_cpm_lite - adjusted_cpm_lite : 0
        let monthly_refund_lite = Math.floor((refund_percentage_lite * monthly_spend_lite)/100)

        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_lite', proposed_sell_cpm_percentage_lite)
        await setFieldValue('refund_percentage_lite', refund_percentage_lite)
        await setFieldValue('refund_cpm_lite', refund_cpm_lite.toFixed(2))
        await setFieldValue('monthly_refund_lite', monthly_refund_lite)

        /* skin */
        let proposed_sell_cpm_percentage_skin = (((client_facing_cpm_skin - adjusted_cpm_skin) / adjusted_cpm_skin) * 100).toFixed(2)        
        let refund_percentage_skin =  adjusted_cpm_skin > 0 ? (((client_facing_cpm_skin - adjusted_cpm_skin) / client_facing_cpm_skin) * 100 ).toFixed(2) : 0
        let refund_cpm_skin = adjusted_cpm_skin > 0 ? client_facing_cpm_skin - adjusted_cpm_skin : 0
        let monthly_refund_skin = Math.floor((refund_percentage_skin * monthly_spend_skin)/100)

        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_skin', proposed_sell_cpm_percentage_skin)
        await setFieldValue('refund_percentage_skin', refund_percentage_skin)
        await setFieldValue('refund_cpm_skin', refund_cpm_skin.toFixed(2))
        await setFieldValue('monthly_refund_skin', monthly_refund_skin)
 
       tmm = monthly_refund_prem + monthly_refund_adv + monthly_refund_skin + monthly_refund_lite
       //console.log(tmm, (monthly_spend_prem + monthly_spend_adv))
        await setFieldValue('total_monthly_refund', tmm)
        await setFieldValue('total_monthly_refund_p', ((tmm / (Number(monthly_spend_prem) + Number(monthly_spend_adv) + Number(monthly_spend_lite) + Number(monthly_spend_skin))) * 100).toFixed(2))
        await setFieldValue('total_annualised_refund', tmm * 12)
    }


    const calculateMargin = async (setFieldValue, updatePercentage = true) => {
        const { proposed_sell_cpm_prem, proposed_sell_cpm_adv, proposed_sell_cpm_lite, proposed_sell_cpm_skin, 
            adjusted_cpm_prem, adjusted_cpm_adv, adjusted_cpm_lite, adjusted_cpm_skin, 
            adjusted_imp_prem, adjusted_imp_adv, adjusted_imp_lite, adjusted_imp_skin,
            monthly_spend_prem, monthly_spend_adv, monthly_spend_lite, monthly_spend_skin,
            
        } = calcFormik?.current?.values

        let tmm = 0;
        //if(type === "prem"){
        //console.log("prem",proposed_sell_cpm_prem)
        let proposed_sell_cpm_percentage_prem = (((proposed_sell_cpm_prem.value - adjusted_cpm_prem) / adjusted_cpm_prem) * 100).toFixed(2)
        let margin_prem = adjusted_cpm_prem > 0 ? (proposed_sell_cpm_prem.value - adjusted_cpm_prem).toFixed(2) : 0
        let total_sell_prem = Math.round(proposed_sell_cpm_prem.value * adjusted_imp_prem / 1000)

        let monthly_margin_prem_2 = Math.round(total_sell_prem - Number(monthly_spend_prem)) || 0
        tmm += monthly_margin_prem_2
        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_prem', proposed_sell_cpm_percentage_prem)
        await setFieldValue('margin_prem', margin_prem)
        await setFieldValue('total_sell_prem', total_sell_prem)
        await setFieldValue('monthly_margin_prem', monthly_margin_prem_2)
        await setFieldValue('margin_percentage_prem', ((monthly_margin_prem_2/total_sell_prem) * 100).toFixed(2))

        //}
        //if(type === "adv"){
        //console.log("adv", proposed_sell_cpm_adv)
        let proposed_sell_cpm_percentage_adv = (((proposed_sell_cpm_adv.value - adjusted_cpm_adv) / adjusted_cpm_adv) * 100).toFixed(2)
        let margin_adv = adjusted_cpm_adv > 0 ? (proposed_sell_cpm_adv.value - adjusted_cpm_adv).toFixed(2) : 0
        let total_sell_adv = Math.round(proposed_sell_cpm_adv.value * adjusted_imp_adv / 1000)

        let monthly_margin_adv_2 = Math.round(total_sell_adv - Number(monthly_spend_adv)) || 0
        tmm += monthly_margin_adv_2
        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_adv', proposed_sell_cpm_percentage_adv)
        await setFieldValue('margin_adv', margin_adv)
        await setFieldValue('total_sell_adv', total_sell_adv)
        await setFieldValue('monthly_margin_adv', monthly_margin_adv_2)
        await setFieldValue('margin_percentage_adv', ((monthly_margin_adv_2/total_sell_adv) * 100).toFixed(2))
        //}
        //console.log(tmm, monthly_margin_prem_2, monthly_margin_adv_2)
        /* LITW */
        let proposed_sell_cpm_percentage_lite = (((proposed_sell_cpm_lite.value - adjusted_cpm_lite) / adjusted_cpm_lite) * 100).toFixed(2)
        let margin_lite = adjusted_cpm_lite > 0 ? (proposed_sell_cpm_lite.value - adjusted_cpm_lite).toFixed(2) : 0
        let total_sell_lite = Math.round(proposed_sell_cpm_lite.value * adjusted_imp_lite / 1000)

        let monthly_margin_lite_2 = Math.round(total_sell_lite - Number(monthly_spend_lite)) || 0
        tmm += monthly_margin_lite_2
        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_lite', proposed_sell_cpm_percentage_lite)
        await setFieldValue('margin_lite', margin_lite)
        await setFieldValue('total_sell_lite', total_sell_lite)
        await setFieldValue('monthly_margin_lite', monthly_margin_lite_2)
        await setFieldValue('margin_percentage_lite', ((monthly_margin_lite_2/total_sell_lite) * 100).toFixed(2))

        /* SKIN */
        let proposed_sell_cpm_percentage_skin = (((proposed_sell_cpm_skin.value - adjusted_cpm_skin) / adjusted_cpm_skin) * 100).toFixed(2)
        let margin_skin = adjusted_cpm_skin > 0 ? (proposed_sell_cpm_skin.value - adjusted_cpm_skin).toFixed(2) : 0
        let total_sell_skin = Math.round(proposed_sell_cpm_skin.value * adjusted_imp_skin / 1000)

        let monthly_margin_skin_2 = Math.round(total_sell_skin - Number(monthly_spend_skin)) || 0
        tmm += monthly_margin_skin_2
        updatePercentage && await setFieldValue('proposed_sell_cpm_percentage_skin', proposed_sell_cpm_percentage_skin)
        await setFieldValue('margin_skin', margin_skin)
        await setFieldValue('total_sell_skin', total_sell_skin)
        await setFieldValue('monthly_margin_skin', monthly_margin_skin_2)
        await setFieldValue('margin_percentage_skin', ((monthly_margin_skin_2/total_sell_skin) * 100).toFixed(2))

        await setFieldValue('total_monthly_margin', tmm)
        await setFieldValue('total_monthly_margin_p', ((tmm / (Number(total_sell_prem) + Number(total_sell_adv))) * 100).toFixed(2))
        await setFieldValue('total_annualised_margin', tmm * 12)
    }

    const handleSellCPMChange = async (type, values, opt, setFieldValue) => {
        calculateMargin(setFieldValue)

    }

    const handleSellPercentageChange = async (type, e, setFieldValue) => {
        let val = Number(e.replaceAll("%", "")) || 0
        //console.log(val)
        //then $ value = Proposed Sell CPM % * Adjusted CPM + Adjusted CPM = 61.62% * $14.85 + $14.85 = $24 rounded to 0 decimal
        const {
            adjusted_cpm_prem, adjusted_cpm_adv,
            adjusted_cpm_lite, adjusted_cpm_skin,

        } = calcFormik?.current?.values

        if (type === "prem") {
            let cpm_prem = Math.round(((val * Number(adjusted_cpm_prem)) / 100) + Number(adjusted_cpm_prem))    

            await setFieldValue("proposed_sell_cpm_prem", { label: cpm_prem, value: cpm_prem, name: `AUD ${cpm_prem} CPM` })
            //document.getElementsByClassName('proposed_sell_cpm_prem')[0].querySelector('.bb-select__value-container').classList.add('blinking-text')
            calculateMargin(setFieldValue, false)
        }
        else if (type === "adv") {
            let cpm_adv = Math.round(((val * Number(adjusted_cpm_adv)) / 100) + Number(adjusted_cpm_adv))
            await setFieldValue("proposed_sell_cpm_adv", { label: cpm_adv, value: cpm_adv, name: `AUD ${cpm_adv} CPM` })
            calculateMargin(setFieldValue, false)
        }
        else if (type === "lite") {
            let cpm_lite = Math.round(((val * Number(adjusted_cpm_lite)) / 100) + Number(adjusted_cpm_lite))
            await setFieldValue("proposed_sell_cpm_lite", { label: cpm_lite, value: cpm_lite, name: `AUD ${cpm_lite} CPM` })
            calculateMargin(setFieldValue, false)
        }
        else if (type === "skin") {
            let cpm_skin = Math.round(((val * Number(adjusted_cpm_skin)) / 100) + Number(adjusted_cpm_skin))
            await setFieldValue("proposed_sell_cpm_skin", { label: cpm_skin, value: cpm_skin, name: `AUD ${cpm_skin} CPM` })
            calculateMargin(setFieldValue, false)
        }

    }

    const handleClientCPMPercentageChange = async (type, e, setFieldValue) => {
        let val = Number(e.replaceAll("%", "")) || 0
        //console.log(val)
        //then $ value = Proposed Sell CPM % * Adjusted CPM + Adjusted CPM = 61.62% * $14.85 + $14.85 = $24 rounded to 0 decimal
        const {
            adjusted_cpm_prem, adjusted_cpm_adv,
            adjusted_cpm_lite, adjusted_cpm_skin,

        } = calcFormik?.current?.values

        if (type === "prem") {
            let cpm_prem = Math.round(((val * Number(adjusted_cpm_prem)) / 100) + Number(adjusted_cpm_prem))
            //console.log(cpm_prem)

            await setFieldValue("proposed_sell_cpm_prem", { label: cpm_prem, value: cpm_prem, name: `AUD ${cpm_prem} CPM` })
            //document.getElementsByClassName('proposed_sell_cpm_prem')[0].querySelector('.bb-select__value-container').classList.add('blinking-text')
            calculateRefund(setFieldValue, false)
        }
        else if (type === "adv") {
            let cpm_adv = Math.round(((val * Number(adjusted_cpm_adv)) / 100) + Number(adjusted_cpm_adv))
            await setFieldValue("proposed_sell_cpm_adv", { label: cpm_adv, value: cpm_adv, name: `AUD ${cpm_adv} CPM` })
            calculateRefund(setFieldValue, false)
        }
        else if (type === "lite") {
            let cpm_lite = Math.round(((val * Number(adjusted_cpm_lite)) / 100) + Number(adjusted_cpm_lite))
            await setFieldValue("proposed_sell_cpm_lite", { label: cpm_lite, value: cpm_lite, name: `AUD ${cpm_lite} CPM` })
            calculateRefund(setFieldValue, false)
        }
        else if (type === "skin") {
            let cpm_skin = Math.round(((val * Number(adjusted_cpm_skin)) / 100) + Number(adjusted_cpm_skin))
            await setFieldValue("proposed_sell_cpm_skin", { label: cpm_skin, value: cpm_skin, name: `AUD ${cpm_skin} CPM` })
            calculateRefund(setFieldValue, false)
        }


    }
    

    const handleManageService = async (v, sf, n) => {
        //console.log(v, n)
        if(n) await sf(n, v)
        setIsManagedService(v)

        let p = createCPMObject(isAU ? minCPM : minCPM + 2)
        let a = createCPMObject(isAU ? advCPM : advCPM + 2)

        let l = createCPMObject(liteCPM + 2)
        let s = createCPMObject(skinCPM + 2)

        if(!v){
            p = PREMIUM_CPM_DISCOUNT_ALL[0]
            a = ADVANCED_CPM_DISCOUNT_ALL[0]
            l = LITE_CPM_DISCOUNT_ALL[0]
            s = SKIN_CPM_DISCOUNT_ALL[0]
        }
        //console.log(p, a, l, s)
        await sf("premium_spend", p)
        await sf("advanced_spend", a)
        await sf("lite_spend", l)
        await sf("skin_spend", s)

        if (model === 2) {
            await sf("premium_spend_set", p)
            await sf("advanced_spend_set", a)
            await sf("lite_spend_set", l)
            await sf("skin_spend_set", s)

            setPrem_spend_set(p)
            setAdv_spend_set(a)
            setLite_spend_set(l)
            setSkin_spend_set(s)
        }
        handleCalculation(sf)

        setPrem_base_set(p)
        setAdv_base_set(a)
        setLite_base_set(l)
        setSkin_base_set(s)
        
        
        //onChange={(e) => handleManageService(e.target.checked, setFieldValue, 'managed_service_refund')}
      /*   if(n === "managed_service_refund"){
            console.log("sdfds")
            await calculateRefundRates(allvalues, sf)
        }
        else if(n === "managed_service_discount"){
            await calculateDiscountFees(allvalues, sf)
        } */
        
    }

    const renderCalcModal = () => {
        //const containerClass = "form-row col-md-12 mb-3", inputClass = "col-sm-12 col-md-7 align-self-center", labelClass = "bb-form-input-label col-5 mw-unset"
        const containerClass = "form-row col-md-12 mb-3";        
        const colB = "col-7"

        return (
            <Modal
                isOpen={isCalcModalOpen}
                onRequestClose={(e) => setIsCalcModalOpen(false)}
                overlayClassName="bb-modal-overlay"
                className={classNames("bb-modal-container", isAU ? "bb-modal-calculator" : "")}
                ariaHideApp={false}
                bodyOpenClassName="overflow-hidden"
            >

                <div className="script-modal" onClick={event => event.stopPropagation()}>
                    <div className="d-flex flex-row justify-content-between mb-3 modal-header bb-bg_primary">
                        <h4 className="text-white"><i className="fas fa-calculator"></i> Usage-Based SaaS Fee Calculator</h4>
                        <div className="bb-modal-close fas fa-times fa-2x cursor-pointer text-white" onClick={(e) => setIsCalcModalOpen(false)}>
                        </div>
                    </div>
                    <Formik
                        innerRef={calcFormik}
                        validationSchema={Schema}
                        enableReinitialize={true}
                        initialValues={{
                            premium_spend_2: pm2, advanced_spend_2: ad2, 
                            lite_spend_2: li2, skin_spend_2: sk2, 
                            monthly_spend_premium: 0,
                            monthly_spend_advanced: 0,
                            monthly_spend_lite: 0,
                            monthly_spend_skin: 0,
                            usage_saas_fee: 0, usage_saas_fee_percentage: 0, paid_to_apex: 0,
                            bigads_saas_fee_percentage: 0, bigads_saas_fee: 0, annual_fee: 0, annual_earnings: 0
                        }}
                    >{({ setFieldValue, dirty, isSubmitting, values, submitCount, errors, isValidating }) =>
                    (
                        <Form autoComplete="off" className="form-row bb-form bb-form-mw pt-4 bb-form-right-align-2-col px-3">

                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-4 pt-3 text-right align-self-center">Client Facing CPM Rate</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    { isAU ?
                                        <div className='mr-3 col-md-6 bb-ad-top cpm-box'>
                                            <label className='mb-0'>{formatText[0]}</label>
                                            <Field name='lite_spend_2' component={SelectInput} options={LITE_CPM}
                                                isEdit={true} placeholder="0" prefixLabel="$"
                                                className="text-right w-137"
                                                label="" />
                                        </div>
                                    : null
                                    }
                                    <div className='mr-3 col-md-6 bb-ad-top cpm-box'>
                                        <label className='mb-0'>{formatText[1]}</label>
                                        <Field name='premium_spend_2' component={SelectInput} options={PREMIUM_CPM}
                                            isEdit={true} placeholder="0" prefixLabel="$"
                                            className="text-right w-137"
                                            label="" />
                                    </div>
                                    <div className='mr-3 col-md-6 bb-ad-top cpm-box'>
                                        <label className='mb-0'>{formatText[2]}</label>
                                        <Field name='advanced_spend_2' component={SelectInput} options={ADVANCED_CPM}
                                            isEdit={true} placeholder="0" prefixLabel="$"
                                            className="text-right w-137"
                                            label="" />
                                    </div>
                                    { isAU ?
                                        <div className='mr-3 col-md-6 bb-ad-top cpm-box'>
                                            <label className='mb-0'>{formatText[3]}</label>
                                            <Field name='skin_spend_2' component={SelectInput} options={SKIN_CPM}
                                                isEdit={true} placeholder="0" prefixLabel="$"
                                                className="text-right w-137" disabled={false}
                                                label="" />
                                        </div>
                                    : null
                                    }
                                </div>
                            </div>

                            <div className={containerClass}>
                                <label className="mb-1 col-md-4 text-right align-self-center">Predicted Monthly Spend</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">                                    
                                    { isAU ?
                                        <div className='mr-3 col-md-6 bb-ad-bottom cpm-box'>
                                            <FastField name='monthly_spend_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={0} component={NumberFormatInput}
                                                className="text-right"
                                                label="" labelClassName="d-none" />
                                        </div>
                                        : null
                                    }
                                    <div className='mr-3 col-md-6 bb-ad-bottom cpm-box'>
                                        <FastField name='monthly_spend_premium' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    <div className='mr-3 col-md-6 bb-ad-bottom cpm-box'>
                                        <FastField name='monthly_spend_advanced' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    { isAU ?
                                        <div className='mr-3 col-md-6 bb-ad-bottom cpm-box'>
                                            <FastField name='monthly_spend_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={0} component={NumberFormatInput}
                                                className="text-right"
                                                label="" labelClassName="d-none" />
                                        </div>
                                    : null
                                    }                                    
                                </div>
                                {errors && errors.sumCheck && (
                                    <span className="required mt-2 w-100 text-center">{errors.sumCheck}</span>)}
                            </div>

                            <button type="button" className="bb-button roas-button p-2 mb-3 mx-auto w-100"
                                disabled={(isSubmitting || !dirty || errors) && Object.keys(errors).length}
                                onClick={() => calculateFees(values, setFieldValue)}>Calculate</button>

                            {showCalculation ? <div className='col-md-12 bb-border-yellow rounded py-3 mb-2 bb-animate fadeIn'>

                                <div className="d-flex flex-row">
                                    <Field name='total_predicted_spend' minValue={0} decimalScale={0} component={NumberFormatInput}
                                        placeholder="0" prefixLabel="$" labelClassName={classNames("mb-1 col-8 pt-2 text-right")}
                                        inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                        className="bb-form-input-label-2 disabled"
                                        label={"Total Monthly Spend"} />

                                </div>
                                <div className="d-flex flex-row">                                   
                                        <div className={classNames("form-row p-0 mb-3", colB)}>
                                            <label className={"mb-1 col-8 pt-2 text-right"}>{"Platform SaaS Fee %"}</label>
                                            <div className="d-flex align-self-center text-center col-4">
                                                <div className='mr-3'>
                                                    <Field name='bigads_saas_fee_percentage' className="text-right disabled maxWidth-186 w-137 bb-form-input-label-2"
                                                        minValue={0} decimalScale={2} placeholder="0%" component={PercentageInput}
                                                        label="" labelClassName="d-none"
                                                    />
                                                </div>
                                            </div>
                                        </div>                                 
                                </div>
                                <div className="d-flex flex-row">                                  
                                        <Field name='bigads_saas_fee' minValue={0} decimalScale={0} component={NumberFormatInput}
                                            placeholder="0" prefixLabel="$" labelClassName={"mb-1 col-8 pt-2 text-right"}
                                            inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                            className="bb-form-input-label-2 disabled "
                                            label={"Total Monthly Platform SaaS Fee"} />                                        
                                </div>
                                <div className="d-flex flex-row">                                  
                                        <Field name='annual_fee' minValue={0} decimalScale={0} component={NumberFormatInput}
                                            placeholder="0" prefixLabel="$" labelClassName={"mb-1 col-8 pt-2 text-right"}
                                            inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                            className="bb-form-input-label-2 disabled "
                                            label={"Total Annualised Platform SaaS Fee"} />                                        
                                </div>
                               
                            </div> : null}
                        </Form>
                    )}
                    </Formik>


                </div>
            </Modal>
        )
    }
    

    const renderRefundCalcModal = () => {
        const containerClass = "form-row col-md-12 mb-3";

        const colB = "col-6"
        return (

            <Modal
                isOpen={isRefundCalcModalOpen}
                onRequestClose={(e) => setIsRefundCalcModalOpen(false)}
                overlayClassName="bb-modal-overlay"
                className={classNames("bb-modal-container","bb-modal-calculator")}
                ariaHideApp={false}
                bodyOpenClassName="overflow-hidden"
            >
                {/* <Slider onRef={ref => setSlider(ref)} touchDisabled={true} slideNo={2}> */}
                    <div key={0} className="script-modal" onClick={event => event.stopPropagation()}>
                        <div className="d-flex flex-row justify-content-between modal-header bb-bg_primary">
                            <h4 className="text-white"><i className="fas fa-calculator"></i> {"Rewards Calculator"}</h4>
                            <div className="bb-modal-close fas fa-times fa-2x cursor-pointer text-white" onClick={(e) => setIsRefundCalcModalOpen(false)}>
                            </div>
                        </div>
                        <Formik
                            innerRef={calcFormik}
                            validationSchema={DiscountSchema}
                            enableReinitialize={true}
                            initialValues={{
                                prem_spend: prem_base_set, adv_spend: adv_base_set, 
                                lite_spend: lite_base_set, skin_spend: skin_base_set, 

                                monthly_spend_prem: 0, monthly_spend_adv: 0,
                                monthly_spend_lite: 0, monthly_spend_skin: 0,

                                adjusted_cpm_prem: 0, adjusted_cpm_adv: 0,
                                adjusted_cpm_lite: 0, adjusted_cpm_skin: 0,

                                proposed_sell_cpm_prem: prem_spend_set, proposed_sell_cpm_adv: adv_spend_set,
                                proposed_sell_cpm_lite: lite_spend_set, proposed_sell_cpm_skin: skin_spend_set,

                                proposed_sell_cpm_percentage_prem: 0, proposed_sell_cpm_percentage_adv: 0,
                                proposed_sell_cpm_percentage_lite: 0, proposed_sell_cpm_percentage_skin: 0,

                                refund_percentage_prem: 0, refund_percentage_adv: 0,
                                refund_percentage_lite: 0, refund_percentage_skin: 0,

                                refund_cpm_prem: 0, refund_cpm_adv: 0,
                                refund_cpm_lite: 0, refund_cpm_skin: 0,

                                monthly_refund_prem: 0, monthly_refund_adv: 0,
                                monthly_refund_lite: 0, monthly_refund_skin: 0,

                                total_monthly_refund_p: 0, total_monthly_refund: 0,
                                total_annualised_refund: 0,
                                managed_service_refund: isManagedService
                            }}
                        >{({ setFieldValue, dirty, isSubmitting, values, submitCount, errors, isValidating }) =>
                        (
                            <Form autoComplete="off" className="form-row bb-form bb-form-mw pt-4 bb-form-right-align-2-col px-3 mr-0">


                                <Field type="hidden" name="managed_service_refund" />
                                {commbank ? null : <div className="form-row col-md-12 mb-2 ">
                                    <label className={classNames("mb-1 col-md-3 text-right align-self-center")}></label>
                                    <div className={classNames("d-flex align-self-center mx-2 col-md-6")}>
                                        <label className={classNames("text-right align-self-center bb-white-space-nowrap")}>Own Trading Desk</label>
                                        <div className="align-self-center mx-1">
                                            {<Toggle
                                                key="toggle-measurement"
                                                checked={isManagedService}
                                                className="toggle-status bb-toggle toggle-blue"
                                                icons={false} 
                                                onChange={(e) => handleManageService(e.target.checked, setFieldValue, 'managed_service_refund')}
                                            />}
                                        </div>
                                        <label className={classNames("align-self-center bb-white-space-nowrap")}>Big Ads Managed Service</label>
                                    </div>
                                </div>}

                                <div className="form-row col-md-12 mb-0">
                                    <label className="mb-1 col-md-3 pt-3 text-right align-self-center">Standard CPM Rate</label>
                                    <div className="d-flex align-self-center mx-2 col-md-6">
                                        {isAU ? 
                                        <div className='mr-3 input-box bb-ad-top text-center'>
                                            <label className='mb-0'>{formatText[0]}</label>
                                            <Field name='lite_spend' component={SelectInput} options={LITE_CPM_DISCOUNT_ALL}
                                                isEdit={true} placeholder="0" prefixLabel="$"
                                                disabled={true}
                                                className="text-right w-137"
                                                label="" />
                                        </div>
                                        : null
                                        }
                                        <div className='mr-3 input-box bb-ad-top text-center'>
                                            <label className='mb-0'>{formatText[1]}</label>
                                            <Field name='prem_spend' component={SelectInput} options={PREMIUM_CPM_DISCOUNT_ALL}
                                                isEdit={true} placeholder="0" prefixLabel="$"
                                                disabled={true}
                                                className="text-right w-137"
                                                label="" />
                                        </div>
                                        <div className='mr-3 input-box bb-ad-top text-center'>
                                            <label className='mb-0'>{formatText[2]}</label>
                                            <Field name='adv_spend' component={SelectInput} options={ADVANCED_CPM_DISCOUNT_ALL}
                                                disabled={true}
                                                isEdit={true} placeholder="0" prefixLabel="$"
                                                className="text-right w-137"
                                                label="" />
                                        </div>
                                        {isAU && isManagedService ?
                                        <div className='mr-3 input-box bb-ad-top text-center'>
                                            <label className='mb-0'>{formatText[3]}</label>
                                            <Field name='skin_spend' component={SelectInput} options={SKIN_CPM_DISCOUNT_ALL}
                                                isEdit={true} placeholder="0" prefixLabel="$"
                                                disabled={true}
                                                className="text-right w-137"
                                                label="" />
                                        </div>
                                        : null }
                                    </div>
                                </div>

                                <div className="form-row col-md-12 mb-0">
                                    <label className="mb-1 col-md-3 text-right align-self-center">Predicted Monthly Spend</label>
                                    <div className="d-flex align-self-center mx-2 col-md-6">
                                        {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                            <FastField name='monthly_spend_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={0} component={NumberFormatInput}
                                                inputContainerClassName="w-137"
                                                className="text-right"
                                                label="" labelClassName="d-none" />
                                        </div>
                                        : null}
                                        <div className='mr-3 input-box bb-ad-side'>
                                            <FastField name='monthly_spend_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={0} component={NumberFormatInput}
                                                inputContainerClassName="w-137"
                                                className="text-right"
                                                label="" labelClassName="d-none" />
                                        </div>
                                        <div className='mr-3 input-box bb-ad-side'>
                                            <FastField name='monthly_spend_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={0} component={NumberFormatInput}
                                                inputContainerClassName="w-137"
                                                className="text-right"
                                                label="" labelClassName="d-none" />
                                        </div>
                                        {isAU && isManagedService ? <div className='mr-3 input-box bb-ad-side'>
                                            <FastField name='monthly_spend_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={0} component={NumberFormatInput}
                                                inputContainerClassName="w-137"
                                                className="text-right"
                                                label="" labelClassName="d-none" />
                                        </div>: null}
                                        
                                    </div>

                                </div>
                                {errors && errors.sumCheck ?
                                    <div className="form-row col-md-12 mb-0">
                                        <label className="mb-1 col-md-3 text-right align-self-center"></label>
                                        <div className='col-md-6 mx-2'><div className="required text-center p-0">{errors.sumCheck}</div></div>
                                    </div> : null
                                }
                                <button type="button" className="bb-button roas-button align-self-center bb-discount-calculate-button"
                                    disabled={(isSubmitting || !dirty || errors) && Object.keys(errors).length}
                                    onClick={() => calculateRefundRates(values, setFieldValue)}>Calculate</button>

                                <div className="form-row col-md-12 mb-0">
                                    <label className="mb-1 col-md-3 text-right align-self-center">Discounted CPM Rate</label>
                                    <div className="d-flex align-self-center mx-2 col-md-6">
                                        {/* <div className='d-flex'> */}
                                        {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                            <FastField name='adjusted_cpm_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={2} component={NumberFormatInput}
                                                inputContainerClassName="w-137"
                                                className="text-right disabled"
                                                label="" labelClassName="d-none" />
                                        </div>:null}
                                        <div className='mr-3 input-box bb-ad-side'>
                                            <FastField name='adjusted_cpm_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={2} component={NumberFormatInput}
                                                className="text-right disabled"
                                                inputContainerClassName="w-137"
                                                label="" labelClassName="d-none" />
                                        </div>
                                        <div className='mr-3 input-box bb-ad-side'>
                                            <FastField name='adjusted_cpm_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                                minValue={0} decimalScale={2} component={NumberFormatInput}
                                                className="text-right disabled"
                                                inputContainerClassName="w-137"
                                                label="" labelClassName="d-none" />
                                        </div>
                                        {isAU  && isManagedService ?
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='adjusted_cpm_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled"
                                                    inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            : null}
                                    </div>
                                </div>

                                {//showDiscountMargin ?
                                    <>

                                        {/* <div className={classNames("form-row col-md-12 mb-0")}>
                                            <label className="mb-1 col-md-3 text-right align-self-center">Client Facing CPM Rate</label>
                                            <div className="d-flex align-self-center mx-2 col-md-6">
                                                
                                                {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='proposed_sell_cpm_lite' component={SelectInput} options={LITE_CPM_DISCOUNT_ALL}
                                                        isEdit={true} placeholder="0" prefixLabel="$"
                                                        onChange={(op, sfv) => calculateRefund(sfv)}
                                                        className="text-right w-132"
                                                        inputContainerClassName={'w-137'}
                                                        label="" />
                                                </div> : null}
                                                <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='proposed_sell_cpm_prem' component={SelectInput} options={PREMIUM_CPM_DISCOUNT_ALL}
                                                        isEdit={true} placeholder="0" prefixLabel="$"
                                                        onChange={(op, sfv) => calculateRefund(sfv)}
                                                        className="text-right w-132"
                                                        inputContainerClassName={'w-137'}
                                                        label="" />
                                                </div>
                                                <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='proposed_sell_cpm_adv' component={SelectInput} options={ADVANCED_CPM_DISCOUNT_ALL}
                                                        isEdit={true} placeholder="0" prefixLabel="$"
                                                        onChange={(op, sfv) => calculateRefund(sfv)}
                                                        className="text-right w-132"
                                                        inputContainerClassName={'w-137'}
                                                        label="" />
                                                </div>
                                                {isAU  && isManagedService  ? <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='proposed_sell_cpm_skin' component={SelectInput} options={SKIN_CPM_DISCOUNT_ALL}
                                                        isEdit={true} placeholder="0" prefixLabel="$"
                                                        onChange={(op, sfv) => calculateRefund(sfv)}
                                                        className="text-right w-132"
                                                        inputContainerClassName={'w-137'}
                                                        label="" />
                                                </div>: null}
                                            </div>
                                        </div>

                                        <div className={classNames("form-row col-md-12 mb-0")}>
                                            <label className="mb-1 col-md-3 text-right align-self-center">% Increase Of Disc. CPM Rate</label>
                                            <div className="d-flex align-self-center mx-2 col-md-6">
                                                {isAU ? <div className='mr-3 input-box bb-ad-side'>        
                                                    <FastField name='proposed_sell_cpm_percentage_lite' placeholder="0%"
                                                        className="text-right w-132"
                                                        decimalScale={2} component={PercentageInput}
                                                        inputContainerClassName={'w-137'}
                                                        onBlur={e => handleClientCPMPercentageChange("lite", e, setFieldValue)}
                                                        label="" labelClassName="d-none" />
                                                </div>: null }
                                                <div className='mr-3 input-box bb-ad-side'>        
                                                    <FastField name='proposed_sell_cpm_percentage_prem' placeholder="0%"
                                                        className="text-right w-132"
                                                        decimalScale={2} component={PercentageInput}
                                                        inputContainerClassName={'w-137'}
                                                        onBlur={e => handleClientCPMPercentageChange("prem", e, setFieldValue)}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                <div className='mr-3 input-box bb-ad-side'>              
                                                    <FastField name='proposed_sell_cpm_percentage_adv' placeholder="0%"
                                                        className="text-right w-132"
                                                        decimalScale={2} component={PercentageInput}
                                                        onBlur={e => handleClientCPMPercentageChange("adv", e, setFieldValue)}
                                                        inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                {isAU  && isManagedService  ? <div className='mr-3 input-box bb-ad-side'>        
                                                    <FastField name='proposed_sell_cpm_percentage_skin' placeholder="0%"
                                                        className="text-right w-132"
                                                        decimalScale={2} component={PercentageInput}
                                                        inputContainerClassName={'w-137'}
                                                        onBlur={e => handleClientCPMPercentageChange("skin", e, setFieldValue)}
                                                        label="" labelClassName="d-none" />
                                                </div>:null}
                                            </div>
                                        </div> */}

                                        <div className={classNames("form-row col-md-12 mb-0")}>
                                            <label className="mb-1 col-md-3 text-right align-self-center">Rewards Percentage</label>
                                            <div className="d-flex align-self-center mx-2 col-md-6">
                                                {/* <div className='d-flex'> */}
                                                {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='refund_percentage_lite' placeholder="0%"                                                        
                                                         className="text-right disabled w-132"
                                                         minValue={0} decimalScale={2} component={PercentageInput}
                                                         inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>:null}
                                                <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='refund_percentage_prem' placeholder="0%"                                                        
                                                         className="text-right disabled w-132"
                                                         minValue={0} decimalScale={2} component={PercentageInput}
                                                         inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='refund_percentage_adv' placeholder="0%"                                                        
                                                         className="text-right disabled w-132"
                                                         minValue={0} decimalScale={2} component={PercentageInput}
                                                         inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                {isAU && isManagedService  ? <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='refund_percentage_skin' placeholder="0%"                                                        
                                                         className="text-right disabled w-132"
                                                         minValue={0} decimalScale={2} component={PercentageInput}
                                                         inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>:null}
                                            </div>
                                        </div>
                                        <div className={classNames("form-row col-md-12 mb-0")}>
                                            <label className="mb-1 col-md-3 text-right align-self-center">Rewards CPM Rate</label>
                                            <div className="d-flex align-self-center mx-2 col-md-6">
                                                {/* <div className='d-flex'> */}
                                                {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='refund_cpm_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div> : null}
                                                <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='refund_cpm_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='refund_cpm_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-side'>
                                                    <FastField name='refund_cpm_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div> : null}
                                            </div>
                                        </div>
                                        <div className={classNames("form-row col-md-12 mb-0")}>
                                            <label className="mb-1 col-md-3 text-right align-self-center">Monthly Rewards</label>
                                            <div className="d-flex align-self-center mx-2 col-md-6">
                                                {/* <div className='d-flex'> */}
                                                {isAU ? <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='monthly_refund_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div> : null}
                                                <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='monthly_refund_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='monthly_refund_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='monthly_refund_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                        minValue={0} decimalScale={2} component={NumberFormatInput}
                                                        className="text-right disabled" inputContainerClassName={'w-137'}
                                                        label="" labelClassName="d-none" />
                                                </div> : null}
                                            </div>
                                        </div>
                                        <div className={classNames("col-md-12  rounded py-3")}>

                                            <div className="d-flex flex-row">
                                                <FastField name='total_monthly_refund_p'  placeholder="0%"    
                                                    labelClassName={classNames("mb-1 col-8 pt-2 text-right")}
                                                    minValue={0} decimalScale={2} component={PercentageInput} 
                                                    inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                                    className="bb-form-input-label-2 disabled w-132"
                                                    label={"Total Rewards Percentage"} />                                                      
                                                        
                                            </div>
                                            <div className="d-flex flex-row">
                                                <FastField name='total_monthly_refund' minValue={0} decimalScale={0} component={NumberFormatInput}
                                                    placeholder="0" prefixLabel="$" labelClassName={classNames("mb-1 col-8 pt-2 text-right")}
                                                    inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                                    className="bb-form-input-label-2 disabled"
                                                    label={"Total Monthly Rewards"} />

                                            </div>
                                            <div className="d-flex flex-row">
                                                <FastField name='total_annualised_refund' minValue={0} decimalScale={0} component={NumberFormatInput}
                                                    placeholder="0" prefixLabel="$" labelClassName={classNames("mb-1 col-8 pt-2 text-right")}
                                                    inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                                    className="bb-form-input-label-2 disabled"
                                                    label={"Total Annualised Rewards"} />

                                            </div>

                                        </div>
                                        {/* </div> */}
                                    </> //: null
                                }
                            </Form>
                        )}
                        </Formik>


                    </div>

                    {/* <div key={1}>
                        <div className="chart-container">
                            <div className="d-flex flex-row justify-content-between mb-3 modal-header bb-bg_primary">
                                <h4 className="text-white">Est. Annualised Refunds Adjusted for Seasonality</h4>
                                <div className="bb-modal-close fas fa-times fa-2x cursor-pointer text-white" onClick={(e) => setIsRefundCalcModalOpen(false)}>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center mt-5">
                                <BuddyChart type="scrollstackedcolumn2d"
                                    width="80%"
                                    height="400"
                                    dataFormat="JSON"
                                    dataSource={createDataSetEstimate()} />
                            </div>

                        </div>
                    </div>

                </Slider> */}
            </Modal>
        )
    }

    const renderDiscountCalcModal = () => {
        const containerClass = "form-row col-md-12 mb-3";

        const colB = "col-6"
        return (
            <Modal
                isOpen={isDiscountCalcModalOpen}
                onRequestClose={(e) => setIsDiscountCalcModalOpen(false)}
                overlayClassName="bb-modal-overlay"
                className="bb-modal-container bb-modal-calculator"
                ariaHideApp={false}
                bodyOpenClassName="overflow-hidden"
            >
                <div className="script-modal" >
                    <div className="d-flex flex-row justify-content-between modal-header bb-bg_primary">
                        <h4 className="text-white"><i className="fas fa-calculator"></i> {"Discount Calculator"}</h4>
                        <div className="bb-modal-close fas fa-times fa-2x cursor-pointer text-white" onClick={(e) => setIsDiscountCalcModalOpen(false)}>
                        </div>
                    </div>
                    <Formik
                        innerRef={calcFormik}
                        validationSchema={DiscountSchema}
                        enableReinitialize={true}
                        initialValues={{
                            prem_spend: prem_base_set, adv_spend: adv_base_set, 
                            lite_spend: lite_base_set, skin_spend: skin_base_set, 

                            monthly_spend_prem: 0, monthly_spend_adv: 0,
                            monthly_spend_lite: 0, monthly_spend_skin: 0,
                        
                            imp_purchased_prem: 0, imp_purchased_adv: 0,
                            imp_purchased_lite: 0, imp_purchased_skin: 0,
                        
                            vol_discount_percentage_prem: 0, vol_discount_percentage_adv: 0,
                            vol_discount_percentage_lite: 0, vol_discount_percentage_skin: 0,
                        
                            adjusted_cpm_prem: 0, adjusted_cpm_adv: 0,
                            adjusted_cpm_lite: 0, adjusted_cpm_skin: 0,
                        
                            imp_increase_prem: 0, imp_increase_adv: 0,
                            imp_increase_lite: 0, imp_increase_skin: 0,
                        
                            adjusted_imp_prem: 0, adjusted_imp_adv: 0,
                            adjusted_imp_lite: 0, adjusted_imp_skin: 0,
                        
                            proposed_sell_cpm_prem: prem_spend_set, proposed_sell_cpm_adv: adv_spend_set,
                            proposed_sell_cpm_lite: lite_spend_set, proposed_sell_cpm_skin: skin_spend_set,
                        
                            proposed_sell_cpm_percentage_prem: 0, proposed_sell_cpm_percentage_adv: 0,
                            proposed_sell_cpm_percentage_lite: 0, proposed_sell_cpm_percentage_skin: 0,
                        
                            margin_prem: 0, margin_adv: 0,
                            margin_lite: 0, margin_skin: 0,
                        
                            total_sell_prem: 0, total_sell_adv: 0,
                            total_sell_lite: 0, total_sell_skin: 0,
                        
                            monthly_margin_prem: 0, monthly_margin_adv: 0,
                            monthly_margin_lite: 0, monthly_margin_skin: 0,

                            total_monthly_margin: 0, total_annualised_margin: 0,
                            managed_service_discount: isManagedService
                        }}
                    >{({ setFieldValue, dirty, isSubmitting, values, submitCount, errors, isValidating }) =>
                    (
                        <Form autoComplete="off" className="form-row bb-form bb-form-mw pt-4 bb-form-right-align-2-col px-3 mr-0">
                            
                            <Field type="hidden" name="managed_service_discount" />
                                {commbank ? null : <div className="form-row col-md-12 mb-2">
                                    <label className={classNames("mb-1 col-md-3 text-right align-self-center")}></label>
                                    <div className={classNames("d-flex align-self-center mx-2 col-md-6")}>
                                    <label className={classNames("text-right align-self-center bb-white-space-nowrap")}>Own Trading Desk</label>
                                        <div className="align-self-center mx-1">
                                            {<Toggle
                                                key="toggle-measurement"
                                                checked={isManagedService}
                                                className="toggle-status bb-toggle toggle-blue"
                                                icons={false} 
                                                onChange={(e) => handleManageService(e.target.checked, setFieldValue, 'managed_service_discount')}
                                            />}
                                        </div>
                                        <label className={classNames("align-self-center bb-white-space-nowrap")}>Big Ads Managed Service</label>
                                    </div>
                                </div>}
                              
                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-3 pt-3 text-right align-self-center">Standard CPM Rate</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    {isAU ? <div className='mr-3 input-box bb-ad-top text-center'>
                                        <label className='mb-0'>{formatText[0]}</label>
                                        <Field name='lite_spend' component={SelectInput} options={LITE_CPM_DISCOUNT_ALL}
                                            isEdit={true} placeholder="0" prefixLabel="$"
                                            disabled={true}
                                            className="text-right w-137"
                                            label="" />
                                    </div>: null}
                                    <div className='mr-3 input-box bb-ad-top text-center'>
                                        <label className='mb-0'>{formatText[1]}</label>
                                        <Field name='prem_spend' component={SelectInput} options={PREMIUM_CPM_DISCOUNT_ALL}
                                            isEdit={true} placeholder="0" prefixLabel="$"
                                            disabled={true}
                                            className="text-right w-137"
                                            label="" />
                                    </div>
                                    <div className='mr-3 input-box bb-ad-top text-center'>
                                        <label className='mb-0'>{formatText[2]}</label>
                                        <Field name='adv_spend' component={SelectInput} options={ADVANCED_CPM_DISCOUNT_ALL}
                                            disabled={true}
                                            isEdit={true} placeholder="0" prefixLabel="$"
                                            className="text-right w-137"
                                            label="" />
                                    </div>
                                    {isAU && isManagedService ? <div className='mr-3 input-box bb-ad-top text-center'>
                                        <label className='mb-0'>{formatText[3]}</label>
                                        <Field name='skin_spend' component={SelectInput} options={SKIN_CPM_DISCOUNT_ALL}
                                            isEdit={true} placeholder="0" prefixLabel="$"
                                            disabled={true}
                                            className="text-right w-137"
                                            label="" />
                                    </div>: null}
                                </div>
                            </div>

                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-3 text-right align-self-center">Predicted Monthly Spend</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    {/* <div className='d-flex'> */}
                                    {isAU ?  <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='monthly_spend_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>:null}
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='monthly_spend_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='monthly_spend_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    {isAU  && isManagedService ?  <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='monthly_spend_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>:null}
                                    {/* </div> */}
                                </div>

                            </div>
                            {errors && errors.sumCheck ?
                                <div className="form-row col-md-12 mb-0">
                                    <label className="mb-1 col-md-3 text-right align-self-center"></label>
                                    <div className='col-md-6 mx-2'><div className="required text-center p-0">{errors.sumCheck}</div></div>
                                </div> : null
                            }
                            <button type="button" className="bb-button roas-button align-self-center bb-discount-calculate-button"
                                disabled={(isSubmitting || !dirty || errors) && Object.keys(errors).length}
                                onClick={() => calculateDiscountFees(values, setFieldValue)}>Calculate</button>
                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-3 text-right align-self-center">Impressions Purchased</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_purchased_lite' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div> : null}
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_purchased_prem' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_purchased_adv' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_purchased_skin' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div> : null}
                                </div>
                            </div>
                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-3 text-right align-self-center">Volume Discount %</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='vol_discount_percentage_lite' placeholder="0%"
                                            className="text-right disabled w-132" inputContainerClassName="w-137"
                                            minValue={0} decimalScale={2} component={PercentageInput}
                                            label="" labelClassName="d-none" />
                                    </div>: null }
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='vol_discount_percentage_prem' placeholder="0%"
                                            className="text-right disabled w-132" inputContainerClassName="w-137"
                                            minValue={0} decimalScale={2} component={PercentageInput}
                                            label="" labelClassName="d-none" />
                                    </div>
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='vol_discount_percentage_adv' 
                                            className="text-right disabled w-132" placeholder="0%"
                                            inputContainerClassName="w-137"
                                            minValue={0} decimalScale={2} component={PercentageInput}
                                            label="" labelClassName="d-none" />
                                    </div>
                                    {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='vol_discount_percentage_skin' placeholder="0%"
                                            className="text-right disabled w-132" inputContainerClassName="w-137"
                                            minValue={0} decimalScale={2} component={PercentageInput}
                                            label="" labelClassName="d-none" />
                                    </div>: null }
                                </div>
                            </div>
                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-3 text-right align-self-center">Discounted CPM Rate</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    {/* <div className='d-flex'> */}
                                    {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='adjusted_cpm_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={2} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div> : null}
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='adjusted_cpm_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={2} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='adjusted_cpm_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={2} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='adjusted_cpm_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                            minValue={0} decimalScale={2} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div> : null}
                                </div>
                            </div>
                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-3 text-right align-self-center">Impressions Increase</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_increase_lite' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>: null} 
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_increase_prem' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_increase_adv' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-side'>
                                        <FastField name='imp_increase_skin' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>: null} 
                                </div>
                            </div>
                            <div className="form-row col-md-12 mb-0">
                                <label className="mb-1 col-md-3 text-right align-self-center">Total Impressions (After Discount)</label>
                                <div className="d-flex align-self-center mx-2 col-md-6">
                                    {isAU ? <div className={classNames('mr-3 input-box', showDiscountMargin ? 'bb-ad-side' : 'bb-ad-bottom')}>
                                        <FastField name='adjusted_imp_lite' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>: null}
                                    <div className={classNames('mr-3 input-box', showDiscountMargin ? 'bb-ad-side' : 'bb-ad-bottom')}>
                                        <FastField name='adjusted_imp_prem' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    <div className={classNames('mr-3 input-box', showDiscountMargin ? 'bb-ad-side' : 'bb-ad-bottom')}>
                                        <FastField name='adjusted_imp_adv' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>
                                    {isAU  && isManagedService ? <div className={classNames('mr-3 input-box', showDiscountMargin ? 'bb-ad-side' : 'bb-ad-bottom')}>
                                        <FastField name='adjusted_imp_skin' isEdit={true} placeholder="0"
                                            minValue={0} decimalScale={0} component={NumberFormatInput}
                                            className="text-right disabled" inputContainerClassName="w-137"
                                            label="" labelClassName="d-none" />
                                    </div>: null}
                                </div>
                            </div>
                            {//showDiscountMargin ?
                                <>
                                    {/* <div className="form-row col-md-12 mb-0 bb-middle-border position-relative">
                                        <label className="mb-1 col-md-3 text-right align-self-center"></label>                                        
                                        <div className="col-md-6 mx-2 accordion-arrow d-flex flex-row cursor-pointer mb-2 justify-content-end" onClick={() => setShowDiscountMargin(!showDiscountMargin)} >
                                            <span >{showDiscountMargin ? "Close Margin Section" : "Calculate Margin"}  <i className={classNames("fas fa-caret-left", showDiscountMargin ? "rotate" : "")} aria-hidden="true"></i></span>
                                        </div>
                                        {showDiscountMargin ? <BilledByAgencyArrow /> : null}
                                    </div> */}

                                    {/* <div className={classNames("accordion-content form-row col-md-12 mb-0", showDiscountMargin ? "open" : "")}> */}
                                    <div className={classNames("accordion-content form-row col-md-12 mb-0", showDiscountMargin ? "open overflow-visible" : "")}>
                                        <label className="mb-1 col-md-3 text-right align-self-center">Client Facing CPM Rate and % Increase</label>
                                        <div className="d-flex align-self-center mx-2 col-md-6">
                                            {isAU ?  <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='proposed_sell_cpm_lite' component={SelectInput} options={LITE_CPM_DISCOUNT_ALL}
                                                    isEdit={true} placeholder="0" prefixLabel="$"
                                                    onChange={(op, sfv) => handleSellCPMChange("lite", values, op, sfv)}
                                                    className="text-right w-132"                                                    
                                                    label="" />
                                                <FastField name='proposed_sell_cpm_percentage_lite' placeholder="0%"
                                                    className="text-right w-132"
                                                    decimalScale={2} component={PercentageInput}
                                                    inputContainerClassName="w-137"
                                                    onBlur={e => handleSellPercentageChange("lite", e, setFieldValue)}
                                                    label="" labelClassName="d-none" />
                                            </div>: null}
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='proposed_sell_cpm_prem' component={SelectInput} options={PREMIUM_CPM_DISCOUNT_ALL}
                                                    isEdit={true} placeholder="0" prefixLabel="$"
                                                    onChange={(op, sfv) => handleSellCPMChange("prem", values, op, sfv)}
                                                    className="text-right w-132"                                                    
                                                    label="" />
                                                <FastField name='proposed_sell_cpm_percentage_prem' placeholder="0%"
                                                    className="text-right w-132"
                                                    decimalScale={2} component={PercentageInput}
                                                    inputContainerClassName="w-137"
                                                    onBlur={e => handleSellPercentageChange("prem", e, setFieldValue)}
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='proposed_sell_cpm_adv' component={SelectInput} options={ADVANCED_CPM_DISCOUNT_ALL}
                                                    isEdit={true} placeholder="0" prefixLabel="$"
                                                    onChange={(op, sfv) => handleSellCPMChange("adv", values, op, sfv)}
                                                    className="text-right w-132"

                                                    label="" />
                                                <FastField name='proposed_sell_cpm_percentage_adv' placeholder="0%"
                                                    className="text-right w-132"
                                                    decimalScale={2} component={PercentageInput}
                                                    onBlur={e => handleSellPercentageChange("adv", e, setFieldValue)}
                                                    inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            {isAU  && isManagedService ?  <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='proposed_sell_cpm_skin' component={SelectInput} options={SKIN_CPM_DISCOUNT_ALL}
                                                    isEdit={true} placeholder="0" prefixLabel="$"
                                                    onChange={(op, sfv) => handleSellCPMChange("skin", values, op, sfv)}
                                                    className="text-right w-132"                                                    
                                                    label="" />
                                                <FastField name='proposed_sell_cpm_percentage_skin' placeholder="0%"
                                                    className="text-right w-132"
                                                    decimalScale={2} component={PercentageInput}
                                                    inputContainerClassName="w-137"
                                                    onBlur={e => handleSellPercentageChange("skin", e, setFieldValue)}
                                                    label="" labelClassName="d-none" />
                                            </div>: null}
                                        </div>
                                    </div>

                                    <div className={classNames("accordion-content form-row col-md-12 mb-0", showDiscountMargin ? "open" : "")}>
                                        <label className="mb-1 col-md-3 text-right align-self-center">Margin CPM Rate</label>
                                        <div className="d-flex align-self-center mx-2 col-md-6">
                                            {/* <div className='d-flex'> */}
                                            {isAU ?  <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='margin_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div> : null}
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='margin_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='margin_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            {isAU  && isManagedService ?  <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='margin_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div> : null}
                                        </div>
                                    </div>
                                    <div className={classNames("accordion-content form-row col-md-12 mb-0", showDiscountMargin ? "open" : "")}>
                                        <label className="mb-1 col-md-3 text-right align-self-center">Total Sell Price to Client</label>
                                        <div className="d-flex align-self-center mx-2 col-md-6">
                                            {/* <div className='d-flex'> */}
                                            {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='total_sell_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div> :null}
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='total_sell_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='total_sell_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='total_sell_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div> :null}
                                        </div>
                                    </div>
                                    <div className={classNames("accordion-content form-row col-md-12 mb-0", showDiscountMargin ? "open" : "")}>
                                        <label className="mb-1 col-md-3 text-right align-self-center">Monthly Margin</label>
                                        <div className="d-flex align-self-center mx-2 col-md-6">
                                            {/* <div className='d-flex'> */}
                                            {isAU ? <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='monthly_margin_lite' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>:null}
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='monthly_margin_prem' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='monthly_margin_adv' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>
                                            {isAU  && isManagedService  ? <div className='mr-3 input-box bb-ad-side'>
                                                <FastField name='monthly_margin_skin' isEdit={true} placeholder="0" prefixLabel="$"
                                                    minValue={0} decimalScale={2} component={NumberFormatInput}
                                                    className="text-right disabled" inputContainerClassName="w-137"
                                                    label="" labelClassName="d-none" />
                                            </div>:null}
                                        </div>
                                    </div>

                                        <div className={classNames("accordion-content form-row col-md-12 mb-0", showDiscountMargin ? "open" : "")}>
                                            <label className="mb-1 col-md-3 text-right align-self-center">Margin Percentage</label>
                                            <div className="d-flex align-self-center mx-2 col-md-6">
                                                {isAU ? <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='margin_percentage_lite' placeholder="0%"
                                                        className="text-right disabled w-132"  inputContainerClassName="w-137"
                                                        minValue={0} decimalScale={2} component={PercentageInput}
                                                        label="" labelClassName="d-none" />
                                                </div> : null}
                                                <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='margin_percentage_prem' placeholder="0%"
                                                        className="text-right disabled w-132"  inputContainerClassName="w-137"
                                                        minValue={0} decimalScale={2} component={PercentageInput}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='margin_percentage_adv' 
                                                    className="text-right disabled w-132" placeholder="0%"
                                                    inputContainerClassName="w-137"
                                                        minValue={0} decimalScale={2} component={PercentageInput}
                                                        label="" labelClassName="d-none" />
                                                </div>
                                                {isAU  && isManagedService ? <div className='mr-3 input-box bb-ad-bottom'>
                                                    <FastField name='margin_percentage_skin' placeholder="0%"
                                                        className="text-right disabled w-132"  inputContainerClassName="w-137"
                                                        minValue={0} decimalScale={2} component={PercentageInput}
                                                        label="" labelClassName="d-none" />
                                                </div> : null}
                                            </div>
                                        </div>
                                    
                                    <div className={classNames("accordion-content col-md-12  rounded py-3 my-2", showDiscountMargin ? "open bb-border-yellow" : "")}>

                                    <div className="d-flex flex-row">
                                                <FastField name='total_monthly_margin_p'  placeholder="0%"    
                                                    labelClassName={classNames("mb-1 col-8 pt-2 text-right")}
                                                    minValue={0} decimalScale={2} component={PercentageInput} 
                                                    inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                                    className="bb-form-input-label-2 disabled w-132"
                                                    label={"Total Margin Percentage"} />                                                      
                                                        
                                            </div>

                                        <div className="d-flex flex-row">
                                            <FastField name='total_monthly_margin' minValue={0} decimalScale={0} component={NumberFormatInput}
                                                placeholder="0" prefixLabel="$" labelClassName={classNames("mb-1 col-8 pt-2 text-right")}
                                                inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                                className="bb-form-input-label-2 disabled"
                                                label={"Total Monthly Margin"} />

                                        </div>
                                        <div className="d-flex flex-row">
                                            <FastField name='total_annualised_margin' minValue={0} decimalScale={0} component={NumberFormatInput}
                                                placeholder="0" prefixLabel="$" labelClassName={classNames("mb-1 col-8 pt-2 text-right")}
                                                inputContainerClassName={"col-4"} containerClassName={classNames("form-row p-0 mb-3", colB)}
                                                className="bb-form-input-label-2 disabled"
                                                label={"Total Annualised Margin"} />

                                        </div>

                                    </div>
                                    {/* </div> */}
                                </> //: null
                            }
                        </Form>
                    )}
                    </Formik>


                </div>

            </Modal>
        )
    }


    const handleSubmit = () => {
        console.log("Approved") //todo
    }
    const handleDateChange = (s, e, setFieldValue) => {
        setFieldValue("startDate", s)
        setFieldValue("endDate", e)
    }

    const onInfoClick = (dealTypeFormatId) => {
        props.getAllObjectives()
        props.getDealTypeFormatCarousel(dealTypeFormatId)
        setIsCarouselModalOpen(true)
    }

    const closeInfoModal = () => {
        props.emptyDealTypeFormatCarousel()
        setIsCarouselModalOpen(false)
    }

    const filterAdsByObjective = (e) => {
        setObj(e.target.value)
    }

    const renderHeader = (onRequestClose) => {
        const { objectives } = props

        return (
            <div className="d-flex flex-column flex-sm-row justify-content-between  pt-3">
                <h3 className="font-weight-bold pt-2 px-4">Ad Formats</h3>
                <div className="d-flex flex-wrap kpi-select pt-2">
                    <StatusFilter status={obj} onChange={filterAdsByObjective} isDefault={false} label="KPI:"
                        placeholder="Choose" optionData={objectives && objectives.data}
                        labelKey="name"
                        valueKey="id"
                    />

                </div>
                <div className="fas fa-times-circle fa-2x cursor-pointer bb-modal-close" onClick={() => onRequestClose()}></div>
            </div>
        );
    }

    const renderCarouselModal = () => {
        const { formatCarousel, formatCarouselLoading } = props;
        let filteredFormats = formatCarousel.filter(format => format.objectiveId.includes(obj));
        return (
            !formatCarouselLoading && <Modal
                isOpen={isCarouselModalOpen}
                onRequestClose={() => closeInfoModal()}
                overlayClassName="bb-modal-overlay"
                className="bb-modal-container mw-900 "
                ariaHideApp={false}
                bodyOpenClassName="overflow-hidden"
            >
                <div className="carousel-container bb-format-container">
                    {renderHeader(() => closeInfoModal())}
                    {<FormatCarouselModal formatCarousel={filteredFormats} onRequestClose={() => closeInfoModal()} />}


                </div>
            </Modal>
        )
    }
    return (
        <>
            <BreadCrumb checkDeep={false} name="Commercials - Setting the rates" />
            {renderCarouselModal()}


            <div className="d-flex flex-column justify-content-center m-3  ">
                <div className="d-flex flex-row align-items-center">
                    <h4 className='text-center flex-grow-1'>{model === 1 ? "Independent Commercials" : model === 2 ? "Unified Volume Rewards Commercials" : "Unified Volume Discount Commercials"}</h4>
                    <RenderEnterpriseLogo></RenderEnterpriseLogo>
                </div>

                {apex ? <div>
                    <Formik
                        innerRef={formik}
                        enableReinitialize={false}
                        initialValues={{
                            company_name: '',
                            startDate: new Date(2025, 1, 1), endDate: new Date(2025, 2, 31),
                            ssp_publisher_enabled: true, criteo_set_enabled: true,
                            receive_enabled: false,
                            premium_spend: model === 1 ? PREMIUM_CPM[0] : PREMIUM_CPM_DISCOUNT_ALL[0],
                            advanced_spend: model === 1 ? PREMIUM_CPM[isAU ? 4 : 2] : ADVANCED_CPM_DISCOUNT_ALL[0],
                            lite_spend: model === 1 ? LITE_CPM[5] : LITE_CPM_DISCOUNT_ALL[0],
                            skin_spend: model === 1 ? SKIN_CPM[10] : SKIN_CPM_DISCOUNT_ALL[0],

                            premium_spend_set: model === 2 ? PREMIUM_CPM_DISCOUNT_ALL[0] : null,
                            advanced_spend_set: model === 2 ? ADVANCED_CPM_DISCOUNT_ALL[0] : null,
                            lite_spend_set: model === 2 ? LITE_CPM_DISCOUNT_ALL[0] : null,
                            skin_spend_set: model === 2 ? SKIN_CPM_DISCOUNT_ALL[0] : null,

                            monthly_spend: monthlySpendBand()[0],
                            support_options: SUPPORT_OPTIONS[1],
                            apex_approver: "", bigads_approver: "",
                            percentage: isAU ? "41.00" : "28.00",
                            percentage_refund: isAU ? "3.33" : "14.71",
                            percentage_discount: isAU ? "10.23": "14.71",
                            bigads_approver_date: new Date(),
                            apex_approver_date: new Date(),
                            first_spend_date: new Date('2025/05/04'),
                            second_spend_date: new Date('2025/08/04'),
                            third_spend_date: new Date('2025/11/04'),
                            fourth_spend_date: new Date('2026/02/04'),
                            
                            set_adjusted_cpm_lite: isAU ? model === 2 ? "6.70" : "6.30" : "14.50",
                            set_adjusted_cpm_prem: isAU ? model === 2 ? "17.40" :"16.00" : "12.50",
                            set_adjusted_cpm_adv: isAU ? model === 2 ? "20.50" : "19.70" : "14.50",                            
                            set_adjusted_cpm_skin: isAU ? model === 2 ? `${formatPricing[3]}.00` : `${formatPricing[3]}.00` : "14.50",
                            
                            managed_service: false
                        }}
                        // validationSchema={ValidationSchema}
                        onSubmit={handleSubmit}
                    >{({ setFieldValue, dirty, errors, isSubmitting, values, submitCount, isValidating }) => (
                        <Form autoComplete="off" className="form-row bb-form bb-form-mw pt-4 bb-form-right-align-2-col">
                            <React.Fragment>
                                <div className="col-md-12">


                                    <FastField className="mb-1" containerClassName={containerClass}
                                        inputContainerClassName={classNames("maxWidth-400", inputClass)}
                                        labelClassName={labelClass} label={"Account Company Name"} placeholder={"Name..."}
                                        name={'company_name'} component={FormInput} type={'text'}

                                    />


                                    <div className={containerClass}>
                                        <label className={classNames(labelClass, "align-self-center")}>Agreement Period</label>
                                        <div className={inputClass}>
                                            <DateRPicker light initStartDate={values.startDate} initEndDate={values.endDate}
                                                maxDate={new Date(2030, 11, 31)}
                                                noLabel={true} onDateChange={(s, e) => handleDateChange(s, e, setFieldValue)} />
                                        </div>
                                    </div>
                                    <div className={containerClass}>
                                        <label className={classNames(labelClass, "align-self-center")}>Prioritise Publishers</label>
                                        <div className={inputClass}>
                                        <PublisherPrioritization />
                                        </div>
                                    </div>
                                    {isBudIndependent ?
                                        <>
                                            <FastField containerClassName={containerClass}
                                                inputContainerClassName={inputClass} name="ssp_publisher_enabled"
                                                labelClassName={classNames(labelClass, "align-self-center")} component={CheckBoxInput} type="checkbox"
                                                label={"Agree To Use Criteo As SSP"}
                                                checkedValue={values.ssp_publisher_enabled} />
                                            {values && !values.ssp_publisher_enabled ?
                                                <>
                                                    <div className={"form-row col-12"}>
                                                        <label className={labelClass}></label>
                                                        <div className={inputClass}>
                                                            <span className={classNames("required")}>
                                                                This option requires Criteo as your SSP. If deselected, the Usage-based SaaS option will not function</span>
                                                        </div>
                                                    </div>
                                                </>
                                                : null}

                                            <FastField containerClassName={containerClass}
                                                inputContainerClassName={classNames(inputClass, "d-flex align-items-center")}
                                                labelClassName={classNames(labelClass, "align-self-center")}
                                                className="col-3"
                                                label={"Agree to Grant Big Ads Criteo Curation Access"} component={CheckBoxInput}
                                                name="criteo_set_enabled" type="checkbox"
                                                checkedValue={values.criteo_set_enabled} />

                                            {values && !values.criteo_set_enabled ?
                                                <>
                                                    <div className={"form-row col-12 mb-2"}>
                                                        <label className={labelClass}></label>
                                                        <div className={inputClass}>
                                                            <span className={classNames("required")}>
                                                                This option requires Criteo as your SSP. If deselected, the Usage-based SaaS option will not function</span>
                                                        </div>
                                                    </div>
                                                </>
                                                : null}
                                        </>

                                        : <FastField containerClassName={containerClass}
                                            inputContainerClassName={classNames(inputClass, "d-flex align-items-center")}
                                            labelClassName={classNames(labelClass, "align-self-center")}
                                            className="col-3"
                                            additionalComponent={isBudIndependent ? null : <>
                                                <CriteoModal />
                                                {values.receive_enabled ? renderFastField("", "Recipient’s email address", "email") : null}
                                            </>}
                                            label={"Receive Monthly Publisher Statement from Criteo"} component={CheckBoxInput}
                                            name="receive_enabled" type="checkbox"
                                            checkedValue={values.receive_enabled} />}

                                    {/* <FastField containerClassName={containerClass}
                                        inputContainerClassName={classNames(inputClass, "d-flex align-items-center")}
                                        labelClassName={classNames(labelClass, "align-self-center")}
                                        className="col-3"
                                        additionalComponent={isBudIndependent ? null : <>
                                                <CriteoModal />
                                                {values.criteo_set_enabled ? renderFastField("", "Recipient’s email address", "email") : null}
                                        </>}
                                        label={isBudIndependent ? "Agree to Grant Big Ads Criteo Curation Access" : "Receive Monthly Publisher Statement from Criteo"} component={CheckBoxInput} name="criteo_set_enabled" type="checkbox"
                                        checkedValue={values.criteo_set_enabled} /> */}




                                    {/* </div>
                                <div className="col-md-12"> */}
                                    <Field name='monthly_spend' component={SelectInput} options={monthlySpendBand()}
                                        isEdit={true} placeholder="0" labelClassName={labelClass}
                                        className="order-1 flex-grow-1"
                                        //customOptionLabel={option => `$${option.min} - $${option.max}`}
                                        onChange={(val) => handleCalculation(setFieldValue)}

                                        inputContainerClassName={classNames(inputClass, "maxWidth-400 d-flex flex-row flex-wrap")} containerClassName={containerClass}
                                        additionalComponent={<FeeModal model={model} />}
                                        label={"Monthly Spend Commitment"} />

                                    {(model === 1) ?
                                        <>
                                            <div className={containerClass}>
                                                <label className={classNames(labelClass, "align-self-center")}>Set Client Facing Minimum CPM Rate</label>
                                                <div className="align-self-center col-7">
                                                    <div className='d-flex'>
                                                    {isAU && renderClientFacingField({
                                                        labelName: formatText[0],
                                                        infoId: '87729f2e-8aab-442c-86cc-3ec4fb684bda',
                                                        fastFieldName: 'lite_spend',
                                                        optionsArray: LITE_CPM,
                                                        disabled: false,
                                                        onInfoClick,
                                                        handleCalculation,
                                                        setFieldValue
                                                        })
                                                    }
                                                    {renderClientFacingField({
                                                        labelName: formatText[1],
                                                        infoId: '988f04d6-9173-41e2-b351-97da7373e083',
                                                        fastFieldName: 'premium_spend',
                                                        optionsArray: PREMIUM_CPM,
                                                        disabled: false,
                                                        onInfoClick,
                                                        handleCalculation,
                                                        setFieldValue
                                                        })
                                                    }
                                                    {renderClientFacingField({
                                                        labelName: formatText[2],
                                                        infoId: 'fb3bfc90-796c-46fa-b86d-84ab2818102b',
                                                        fastFieldName: 'advanced_spend',
                                                        optionsArray: ADVANCED_CPM,
                                                        disabled: false,
                                                        onInfoClick,
                                                        handleCalculation,
                                                        setFieldValue
                                                        })
                                                    }
                                                    {isAU && renderClientFacingField({
                                                        labelName: formatText[3],
                                                        infoId: 'e659a9f9-541a-4a36-a11f-ef84df500c2f',
                                                        fastFieldName: 'skin_spend',
                                                        optionsArray: SKIN_CPM,
                                                        disabled: false,
                                                        onInfoClick,
                                                        handleCalculation,
                                                        setFieldValue
                                                        })
                                                    }                                                  
                                                    </div>
                                                    <label className='bb-font_13px align-content-center mb-0'>{"CPM prices can be increased at campaign level, but not lowered"}</label>
                                                </div>
                                            </div>


                                            <FastField className="mb-1 disabled maxWidth-400  w-137" containerClassName={containerClass}
                                                inputContainerClassName={classNames(inputClass, "d-flex flex-row flex-wrap")} labelClassName={labelClass}
                                                label={"Estimated Usage-Based SaaS Fee"} placeholder="0.00%" name="percentage" component={PercentageInput} />


                                            <div className={classNames(containerClass, "justify-content-center")}>
                                                <label className={labelClass}></label>
                                                <div className="align-self-center col-7">
                                                    <button type="button" onClick={() => { setIsCalcModalOpen(true) }} className={"p-2 bb-button roas-button border-0 mt-0 mw-unset"} >
                                                        <i className="fas fa-calculator"></i> Usage-Based SaaS Fee Calculator
                                                    </button>
                                                </div>
                                            </div>

                                            <Field name='support_options' component={SelectInput} options={SUPPORT_OPTIONS}
                                                isEdit={true} placeholder="0" labelClassName={labelClass}
                                                className="order-1 flex-grow-1"
                                                onChange={(val) => { }}
                                                inputContainerClassName={classNames(inputClass, "maxWidth-400 d-flex flex-row flex-wrap")} containerClassName={containerClass}
                                                additionalComponent={<SupportModal />}
                                                label={"Support Options"} />
                                        </>
                                        : null}

                                    {(model === 2 || model === 3) ?
                                        <>
                                            <Field type="hidden" name="managed_service" />
                                                        {commbank ? null : <div className={containerClass}>
                                                            <label className={classNames(labelClass, "align-self-center bb-white-space-nowrap")}>Own Trading Desk</label>
                                                            <div className={classNames("d-flex align-self-center col-7 pt-2")}>
                                                                {/* <label className={classNames("text-right align-self-center bb-white-space-nowrap")}></label> */}
                                                                <div className="align-self-center">
                                                                    {<Toggle
                                                                        key="toggle-measurement"
                                                                        checked={values.managed_service}
                                                                        className="toggle-status bb-toggle toggle-blue"
                                                                        icons={false} 
                                                                        onChange={(e) => handleManageService(e.target.checked, setFieldValue, 'managed_service')}
                                                                    />}
                                                                </div>
                                                                <label className={classNames("align-self-center bb-white-space-nowrap ml-2")}>Big Ads Managed Service</label>
                                                            </div>
                                                        </div>}
                                            <div className={containerClass}>
                                                <label className={classNames(labelClass, "align-self-center")}>Standard CPM Rate</label>
                                                <div className="align-self-center col-7">
                                                        <div className='d-flex'>
                                                            {isAU && renderClientFacingField({
                                                                labelName: formatText[0],
                                                                infoId: '87729f2e-8aab-442c-86cc-3ec4fb684bda',
                                                                fastFieldName: 'lite_spend',
                                                                optionsArray: LITE_CPM_DISCOUNT_ALL,
                                                                disabled: true,
                                                                onInfoClick,
                                                                handleCalculation,
                                                                setFieldValue,
                                                                topContainerClassName: 'mr-2 ww-100',
                                                                fContainerClassName: 'pr-2'
                                                            })
                                                            }
                                                            {renderClientFacingField({
                                                                labelName: formatText[1],
                                                                infoId: '988f04d6-9173-41e2-b351-97da7373e083',
                                                                fastFieldName: 'premium_spend',
                                                                optionsArray: PREMIUM_CPM_DISCOUNT_ALL,
                                                                disabled: true,
                                                                onInfoClick,
                                                                handleCalculation,
                                                                setFieldValue,
                                                                topContainerClassName: 'mr-2 ww-100',
                                                                fContainerClassName: 'pr-2'
                                                            })
                                                            }
                                                            {renderClientFacingField({
                                                                labelName: formatText[2],
                                                                infoId: 'fb3bfc90-796c-46fa-b86d-84ab2818102b',
                                                                fastFieldName: 'advanced_spend',
                                                                optionsArray: ADVANCED_CPM_DISCOUNT_ALL,
                                                                disabled: true,
                                                                onInfoClick,
                                                                handleCalculation,
                                                                setFieldValue,
                                                                topContainerClassName: 'mr-2 ww-100',
                                                                fContainerClassName: 'pr-2'
                                                            })
                                                            }
                                                            {isAU && isManagedService && renderClientFacingField({
                                                                labelName: formatText[3],
                                                                infoId: 'e659a9f9-541a-4a36-a11f-ef84df500c2f',
                                                                fastFieldName: 'skin_spend',
                                                                optionsArray: SKIN_CPM_DISCOUNT_ALL,
                                                                disabled: true,
                                                                onInfoClick,
                                                                handleCalculation,
                                                                setFieldValue,
                                                                topContainerClassName: 'mr-2 ww-100',
                                                                fContainerClassName: 'pr-2'
                                                            })
                                                            }
                                                        </div>

                                                </div>

                                            </div>
                                            <div className={containerClass}>
                                                <label className={classNames(labelClass, "align-self-center")}>Discounted CPM Rate</label>
                                                <div className="align-self-center col-7">
                                                    <div className='d-flex'>
                                                       
                                                        {isAU && renderDiscountedCPMField({ fieldName: 'set_adjusted_cpm_lite'})}
                                                        {renderDiscountedCPMField({ fieldName: 'set_adjusted_cpm_prem'})}
                                                        {renderDiscountedCPMField({ fieldName: 'set_adjusted_cpm_adv'})}
                                                        {isAU && isManagedService && renderDiscountedCPMField({ fieldName: 'set_adjusted_cpm_skin'})}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className={containerClass}>
                                                <label className={classNames(labelClass, "align-self-center")}>
                                                Set Client Facing Minimum CPM Rate {model == 3 ? <small>(optional)</small> : null}</label>
                                                <div className="align-self-center col-7">
                                                    <div className='d-flex'>
                                                        {  isAU ?
                                                            <div className='mr-2 ww-100 pt-1'>
                                                            <FastField name='lite_spend_set' component={SelectInput} options={LITE_CPM_DISCOUNT_ALL}
                                                                isEdit={true} placeholder="$0" prefixLabel="$"
                                                                onChange={(val) => handleSetSellCPM(setFieldValue)}
                                                                containerClassName="pr-2"
                                                                label="" />
                                                        </div>
                                                        :null
                                                        }
                                                        <div className='mr-2 ww-100 pt-1'>
                                                            <FastField name='premium_spend_set' component={SelectInput} options={PREMIUM_CPM_DISCOUNT_ALL}
                                                                isEdit={true} placeholder="$0" prefixLabel="$"
                                                                onChange={(val) => handleSetSellCPM(setFieldValue)}
                                                                containerClassName="pr-2"
                                                                label="" />
                                                        </div>
                                                        <div className=''>
                                                            <FastField name='advanced_spend_set' component={SelectInput} options={ADVANCED_CPM_DISCOUNT_ALL}
                                                                onChange={(val) => handleSetSellCPM(setFieldValue)}
                                                                inputContainerClassName="d-flex flex-row flex-wrap "
                                                                className="order-1 flex-grow-1 ww-100 pr-2"
                                                                isEdit={true} placeholder="$0" prefixLabel="$"
                                                                containerClassName="pr-2"

                                                                additionalComponent={(model === 3 && !isAU) ? <DiscountSellCPMModal /> : null}
                                                                label="" />
                                                        </div>
                                                        { isAU && isManagedService ?
                                                        <div className='mr-2'>
                                                            <FastField name='skin_spend_set' component={SelectInput} options={SKIN_CPM_DISCOUNT_ALL}
                                                                onChange={(val) => handleSetSellCPM(setFieldValue)}
                                                                inputContainerClassName="d-flex flex-row flex-wrap "
                                                                className="order-1 flex-grow-1 ww-100 pr-2"
                                                                isEdit={true} placeholder="$0" prefixLabel="$"
                                                                containerClassName="pr-2"
                                                                disabled={false}
                                                                additionalComponent={(model === 3 ) ? <DiscountSellCPMModal /> : null}
                                                                label="" />
                                                        </div> : null
                                                            }
                                                    </div>
                                                </div>


                                            </div> */}
                                        </>
                                        : null
                                    }

                                    {model === 2 ?
                                        <FastField className="mb-1 disabled maxWidth-400  w-137" containerClassName={containerClass}
                                            inputContainerClassName={classNames(inputClass, "d-flex flex-row flex-wrap")} labelClassName={labelClass}
                                            label={"Rewards Percentage"} placeholder="0.00%" name="percentage_refund" component={PercentageInput} />
                                        : null}
                                    
                                    {model === 3 ?
                                        <FastField className="mb-1 disabled maxWidth-400  w-137" containerClassName={containerClass}
                                            inputContainerClassName={classNames(inputClass, "d-flex flex-row flex-wrap")} labelClassName={labelClass}
                                            label={"Discount Percentage"} placeholder="0.00%" name="percentage_discount" component={PercentageInput} />
                                        : null}
                                </div>
                                {!isBudIndependent ?
                                    <div className={classNames(containerClass, "justify-content-center")}>
                                        <label className={labelClass}></label>
                                        <div className="align-self-center col-7">
                                            <button type="button" onClick={() => { model === 3 ? setIsDiscountCalcModalOpen(true) : setIsRefundCalcModalOpen(true) }} className={"p-2 bb-button roas-button border-0 mt-0 mw-unset"} >
                                                <i className="fas fa-calculator"></i> {`${model === 2 ? "Rewards Calculator" : "Discount Calculator"} `}
                                            </button>
                                        </div>
                                    </div>
                                    : null}
                                <div className={containerClass}>
                                    <label className={classNames(labelClass, "align-self-center pt-4")}>Lock-In Spend Review Dates</label>
                                    <div className="align-self-center col-7">
                                        <div className='d-flex'>
                                            <div className='mr-3 d-flex flex-column align-items-center'>
                                                <label className='mb-0'><i className="fas fa-calendar-alt" />
                                                    <span> 1<sup>st</sup>
                                                    </span></label>
                                                <FastField
                                                    labelClassName="mr-2"
                                                    containerClassName="d-flex mr-2" inputContainerClassName=""
                                                    dateFormat="yyyy-MM-dd"
                                                    label="" name="first_spend_date" component={CustomDatePicker} setFieldValue={setFieldValue} />
                                            </div>
                                            <div className='mr-3 d-flex flex-column align-items-center'>
                                                <label className='mb-0'><i className="fas fa-calendar-alt" />
                                                    <span> 2<sup>nd</sup>
                                                    </span></label>
                                                <FastField
                                                    labelClassName="mr-2"
                                                    containerClassName="d-flex mr-2" inputContainerClassName="" dateFormat="yyyy-MM-dd"
                                                    label="" name="second_spend_date" component={CustomDatePicker} setFieldValue={setFieldValue} />
                                            </div>
                                            <div className='mr-3 d-flex flex-column align-items-center'>
                                                <label className='mb-0'><i className="fas fa-calendar-alt" />
                                                    <span> 3<sup>rd</sup>
                                                    </span></label>
                                                <FastField
                                                    labelClassName="mr-2"
                                                    containerClassName="d-flex mr-2" inputContainerClassName="" dateFormat="yyyy-MM-dd"
                                                    label="" name="third_spend_date" component={CustomDatePicker} setFieldValue={setFieldValue} />
                                            </div>
                                            <div className='mr-3 d-flex flex-column align-items-center'>
                                                <label className='mb-0'><i className="fas fa-calendar-alt" />
                                                    <span> 4<sup>th</sup>
                                                    </span></label>
                                                <FastField
                                                    labelClassName="mr-2"
                                                    containerClassName="d-flex mr-2" inputContainerClassName=""
                                                    dateFormat="yyyy-MM-dd"
                                                    label="" name="fourth_spend_date" component={CustomDatePicker} setFieldValue={setFieldValue} />
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <div className="d-flex flex-row bb-border-gray rounded py-3 mb-2 mx-auto flex-wrap">
                                    {renderTAndC()}
                                    <div className='row mx-auto'>
                                        <div className='col-9 pr-0'>
                                            <div className='d-flex row mb-3 col-12 pr-0'>
                                                <div className='col-7'>
                                                    {renderFastField("Authorised Approver", "TBA", "apex_approver")}
                                                </div>
                                                <div className='col-3'>
                                                    <div className='d-flex'>
                                                        <FastField
                                                            labelClassName="mr-2"
                                                            containerClassName="d-flex mr-2" inputContainerClassName=""
                                                            label="Date" name="apex_approver_date" component={CustomDatePicker} setFieldValue={setFieldValue} />
                                                        <button type="button" className="bb-button bb-bg_blue ripple" ref={aaButtonRef}
                                                            onClick={() => handleApproveClick(aaButtonRef)} disabled={!scrollTCsAtBottom}>Approve</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex row col-12 pr-0'>
                                                <div className='col-7'>
                                                    {renderFastField("Big Ads Approver", "Jack Huang", "bigads_approver")}
                                                </div>
                                                <div className='col-3'>
                                                    <div className='d-flex'>
                                                        <FastField
                                                            labelClassName="mr-2"
                                                            containerClassName="d-flex mr-2" inputContainerClassName=""
                                                            label="Date" name="bigads_approver_date" component={CustomDatePicker} setFieldValue={setFieldValue} />
                                                        <button type="button" className="bb-button bb-bg_blue ripple" ref={baButtonRef}
                                                            onClick={() => handleApproveClick(baButtonRef)} disabled={!scrollTCsAtBottom}>Approve</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <AgreementModal url={tcsURL} />
                                        <div className="col">
                                            <div className='d-flex row mb-3'>
                                                <button type="button" onClick={() => pushLocation("/commercials")} className="bb-button bb-back-button" disabled={false}>Cancel</button>
                                            </div>
                                            <div className='d-flex row mb-3'>
                                                <AcceptModal model={model} /></div>
                                        </div>
                                    </div>
                                </div>

                            </React.Fragment>

                            {/* <ValidationError submitCount={submitCount} isValidating={isValidating && isSubmitting} errors={!isEmpty(errors)} /> */}
                        </Form>
                    )}
                    </Formik>
                </div> : null}

                {renderCalcModal()}
                {renderDiscountCalcModal()}
                {renderRefundCalcModal()}
            </div>
        </>
    )
}
const mapStateToProps = state => ({


    objectives: state.showcase.helpers.objectives || [],
    formatCarousel: state.audiences.Contextual.formatCarousel || [],
    formatCarouselLoading: state.audiences.Contextual.formatCarouselLoading,
    user: state.user,

    CMPModel: state.showcase.helpers.CMPModel || [],


});
const mapDispatchToProps = {

    getDealTypeFormatCarousel,
    emptyDealTypeFormatCarousel,
    getCMPByCountryModel,

    getAllObjectives, emptyObjectives,

};
export default (connect(mapStateToProps, mapDispatchToProps)(Rates));